import {
  AccountCircleRounded,
  SaveRounded,
  FilterAltRounded,
  SkipPreviousRounded,
  SkipNextRounded,
  FastForwardRounded,
  CloseRounded,
  RadioButtonUncheckedRounded,
  CheckCircleOutlineRounded,
  HelpOutlineRounded,
  RefreshRounded,
  OpenInNewRounded,
  DoubleArrowRounded,
  CancelRounded,
  FormatListBulletedRounded,
  WrapTextRounded,
  CompressRounded,
  FileOpenRounded,
  ExpandRounded,
  FileUploadRounded,
  FileDownloadRounded,
  TaskRounded,
  ReplyRounded
} from "@mui/icons-material"
import {
  BsTranslate
} from "react-icons/bs"
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  Typography
} from "@mui/material"
import debounce from 'lodash.debounce'
import { useNavigate } from "react-router-dom"
import Navigation from "../components/navigation"
import {
  styles,
  stylesDark,
  Styles,
  useTheme
} from "../providers/theme"
import { makeStyles } from "@mui/styles"
import makeToast from "../components/toast"
import {
  CSSProperties,
  ChangeEvent,
  Dispatch,
  RefObject,
  SetStateAction,
  createRef,
  useEffect,
  useState,
  useCallback
} from "react"
import { useAuth } from "../providers/auth"
import { useTranslationFiles } from "../providers/translationFiles"
import { socket } from ".."
import { CustomSelect } from "../components/customSelect"
import { MultiplePropertiesArea, PropertyArea } from "../components/propertyArea"
import { List, AutoSizer } from "react-virtualized"
import { LoadingButton } from "@mui/lab"
import formatXml from 'xml-formatter'

declare const window: any

const useStylesLight = makeStyles<any, Styles>({...styles})
const useStylesDark = makeStyles<any, Styles>({...stylesDark})

export default function Translation() {
  const navigate = useNavigate()
  const title = 'Translation'
  const {mode} = useTheme()
  let classesLight = useStylesLight(styles)
  let classesDark = useStylesDark(stylesDark)
  const classes = mode === 'light' ? classesLight : classesDark
  const {user, currentRole} = useAuth()

  // File related
  const [contexts, setContexts] = useState<any>(undefined)
  const [contextsNames, setContextsNames] = useState<string[]>([])
  const [currentContext, setCurrentContext] = useState<string>("")
  const [previousContext, setPreviousContext] = useState<string>("")
  const [fieldIndex, setFieldIndex] = useState<number>(-1)
  const [sources, setSources] = useState<any[]>([])
  const [translations, setTranslations] = useState<any[]>([])
  const [messages, setMessages] = useState<any[]>([])
  const [currentTranslation, setCurrentTranslation] = useState<string>("")
  const [currentTranslations, setCurrentTranslations] = useState<string[]>([])
  const [fileContent, setFileContent] = useState<Document>()
  const [autoTranslationSupported, setAutoTranslationSupported] = useState<boolean>(false)
  const [fieldType, setFieldType] = useState<"done" | "unfinished" | "unverified">("unfinished")
  const [fieldTypes, setFieldTypes] = useState<("done" | "unfinished" | "unverified")[]>([])
  const [autoTranslateFilePressed, setAutoTranslateFilePressed] = useState<boolean>(false)
  const [refreshPressed, setRefreshPressed] = useState<boolean>(false)

  // Loading variables for buttons that send request to the backend to avoid spamming requests
  const [autoTranslateFileLoading, setAutoTranslateFileLoading] = useState<boolean>(false)
  const [autoTranslateFieldLoading, setAutoTranslateFieldLoading] = useState<boolean>(false)
  const [clearHistoryLoading, setClearHistoryLoading] = useState<boolean>(false)

  const [selectedTranslationFilesCategory, setSelectedTranslationFilesCategory] = useState<string>("")
  const [selectedFilesCategory, setSelectedFilesCategory] = useState<string>("")
  const [selectedTranslationFile, setSelectedTranslationFile] = useState<string>("")
  const [selectedFirmwareVersion, setSelectedFirmwareVersion] = useState<string>("")
  const [availableTranslationFilesCategories, setAvailableTranslationFilesCategories] = useState<string[]>([])
  const [availableFirmwareVersions, setAvailableFirmwareVersions] = useState<string[]>([])
  const {speechTranslationFilesFW2, webInterfaceTranslationFilesFW2, speechTranslationFilesFW3, webInterfaceTranslationFilesFW3, IBTGTranslationFiles} = useTranslationFiles()
  const translationFilesCategories: any = {
    "Speech": "speech",
    "Web Interface": "web-interface"
  }
  const filesCategories: string[] = ["Embosser", "Index Braille Tactile Graphics"]
  const fileInput: RefObject<HTMLInputElement> = createRef()
  const [displayMode, setDisplayMode] = useState<string>(() => {
    const savedDisplayMode = localStorage.getItem("translationFileFieldsDisplayMode")
    return JSON.parse(savedDisplayMode!) || "items"
  })

  // Firmware select dialog
  const [selectFirmwareVersionDialogOpen, setSelectFirmwareVersionDialogOpen] = useState<boolean>(false)

  // File select dialog
  const [selectFileDialogOpen, setSelectFileDialogOpen] = useState<boolean>(false)

  // File modified notification dialog
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  // [S.S.] Close file notification dialog
  const [closeFileDialogOpen, setCloseFileDialogOpen] = useState<boolean>(false)
  const [closeFileOnSelectFileDialogOpen, setCloseFileOnSelectFileDialogOpen] = useState<boolean>(false)
  const [fileClosed, setFileClosed] = useState<boolean>(false)

  // Dialog for items which are not on the filtered list.
  const [openItemNotOnListDialog, setOpenItemNotOnListDialog] = useState(false);

  // Filter
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [sentenceStateFilter, setSentenceStateFilter] = useState<string>("Unfinished;Translated by DeepL")
  const [contextFilter, setContextFilter] = useState<string>("None")
  const [filteredSources, setFilteredSources] = useState<any[]>([])
  const [filteredTranslations, setFilteredTranslations] = useState<any[]>([])
  const [filteredMessages, setFilteredMessages] = useState<any[]>([])
  const [nonEmptyContexts, setNonEmptyContexts] = useState<string[]>([])
  const [filteredItems, setFilteredItems] = useState<any>({})

  // Search
  const [search, setSearch] = useState<string>("")

  // History
  const [historyModalOpen, setHistoryModalOpen] = useState<boolean>(false)
  const [historyEntryChanges, setHistoryEntryChanges] = useState<any>({})
  const [history, setHistory] = useState<{fileName: string, userName: string, userPhotoURL: string, date: number, changes: any}[]>([])
  const [initialItems, setInitialItems] = useState<any>({})

  // List View
  const [listViewBoxSize, setListViewBoxSize] = useState<number>(200)

  // [S.S.] Items View
  const [findSource, setFindSource] = useState<string>("")
  const [findItemReady, setFindItemReady] = useState<boolean>(false)

  const searchSentences = (search: string, sentenceStateFilter: string, sources: any[], translations: any[], messages: any[], previousContext: string, currentContext: string, contextFilter: string, contexts: any, displayMode: string) => {
    let newFilteredSources: any[] = []
    let newFilteredTranslations: any[] = []
    let newFilteredMessages: any[] = []

    let newFilteredIndexes: Set<number> = new Set([])
    let partialNewFilteredIndexes: number[] = []

    let newFilteredItems: any = {}

    let filters = sentenceStateFilter.split(';')
    let selectedContexts = contextFilter.split(';')

    if (contexts !== undefined) {
      for (let selectedContext of selectedContexts) {
        let selectedContextSources = contexts[selectedContext].sources
        let selectedContextTranslations = contexts[selectedContext].translations
        let selectedContextMessages = contexts[selectedContext].messages
        newFilteredIndexes = new Set([])

        partialNewFilteredIndexes = []
        if (filters.includes("Translated")) {
          partialNewFilteredIndexes = selectedContextSources.reduce((accumulator: number[], source: any, index: any) => {
            if (selectedContextTranslations[index].getAttribute("type") === null && selectedContextMessages[index].innerHTML !== "Translated by DeepL" && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || selectedContextTranslations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))) {
              accumulator.push(index)
            }
            return accumulator
          }, [])
        }
        newFilteredIndexes = new Set([...newFilteredIndexes, ...partialNewFilteredIndexes])

        partialNewFilteredIndexes = []
        if (filters.includes("Unfinished")) {
          partialNewFilteredIndexes = selectedContextSources.reduce((accumulator: number[], source: any, index: number) => {
            if (selectedContextTranslations[index].getAttribute("type") === "unfinished" && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || selectedContextTranslations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))) {
              accumulator.push(index)
            }
            return accumulator
          }, [])
        }
        newFilteredIndexes = new Set([...newFilteredIndexes, ...partialNewFilteredIndexes])

        partialNewFilteredIndexes = []
        if (filters.includes("Translated by DeepL")) {
          partialNewFilteredIndexes = selectedContextMessages.reduce((accumulator: number[], message: any, index: number) => {
            if (message.innerHTML === "Translated by DeepL" && (selectedContextSources[index].innerHTML.toLowerCase().includes(search.toLowerCase()) || selectedContextTranslations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))) {
              accumulator.push(index)
            }
            return accumulator
          }, [])
        }
        newFilteredIndexes = new Set([...newFilteredIndexes, ...partialNewFilteredIndexes])

        newFilteredItems[selectedContext] = {}
        newFilteredItems[selectedContext].indexes = []
        newFilteredItems[selectedContext].sources = []
        newFilteredItems[selectedContext].translations = []
        newFilteredItems[selectedContext].messages = []
        let fieldIndex = 0
        for (let index of [...newFilteredIndexes].sort((firstIndex, secondIndex) => firstIndex - secondIndex)) {
          newFilteredItems[selectedContext].indexes.push(fieldIndex)
          newFilteredItems[selectedContext].sources.push(selectedContextSources[index])
          newFilteredItems[selectedContext].translations.push(selectedContextTranslations[index])
          newFilteredItems[selectedContext].messages.push(selectedContextMessages[index])
          fieldIndex += 1
        }
      }
    }
    setFilteredItems(newFilteredItems)

    partialNewFilteredIndexes = []
    newFilteredIndexes = new Set([])
    if (filters.includes("Translated")) {
      sources.filter((source, index) => {
        if (translations[index].getAttribute("type") === null && messages[index].innerHTML !== "Translated by DeepL" && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || translations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))) {
          partialNewFilteredIndexes.push(index)
        }
        return translations[index].getAttribute("type") === null && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || translations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))
      })
    }
    newFilteredIndexes = new Set([...newFilteredIndexes, ...partialNewFilteredIndexes])

    partialNewFilteredIndexes = []
    if (filters.includes("Unfinished")) {
      sources.filter((source, index) => {
        if (translations[index].getAttribute("type") === "unfinished" && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || translations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))) {
          partialNewFilteredIndexes.push(index)
        }
        return translations[index].getAttribute("type") === "unfinished" && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || translations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))
      })
    }
    newFilteredIndexes = new Set([...newFilteredIndexes, ...partialNewFilteredIndexes])

    partialNewFilteredIndexes = []
    if (filters.includes("Translated by DeepL")) {
      messages.filter((message, index) => {
        if (message.innerHTML === "Translated by DeepL" && (sources[index].innerHTML.toLowerCase().includes(search.toLowerCase()) || translations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))) {
          partialNewFilteredIndexes.push(index)
        }
        return message.innerHTML === "Translated by DeepL" && (sources[index].innerHTML.toLowerCase().includes(search.toLowerCase()) || translations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))
      })
    }
    newFilteredIndexes = new Set([...newFilteredIndexes, ...partialNewFilteredIndexes])

    for (let index of [...newFilteredIndexes].sort((firstIndex, secondIndex) => firstIndex - secondIndex)) {
      newFilteredSources.push(sources[index])
      newFilteredTranslations.push(translations[index])
      newFilteredMessages.push(messages[index])
    }

    setFilteredSources(newFilteredSources)
    setFilteredTranslations(newFilteredTranslations)
    setFilteredMessages(newFilteredMessages)

    // [S.S.] Updating the nonEmptyContexts state variable
    let newNonEmptyContexts: string[] = []
    if (contexts !== undefined) {
      for (let selectedContext of selectedContexts) {
        let selectedContextSources = contexts[selectedContext].sources
        let selectedContextTranslations = contexts[selectedContext].translations
        let selectedContextMessages = contexts[selectedContext].messages
        let selectedContextIsEmpty = true
        if (filters.includes("Translated")) {
          if (selectedContextSources.filter((source: any, index: any) => {
            return selectedContextTranslations[index].getAttribute("type") === null && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || selectedContextTranslations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))
          }).length !== 0) {
            selectedContextIsEmpty = false
          }
        }
        if (filters.includes("Unfinished")) {
          if (selectedContextSources.filter((source: any, index: any) => {
            return selectedContextTranslations[index].getAttribute("type") === "unfinished" && (source.innerHTML.toLowerCase().includes(search.toLowerCase()) || selectedContextTranslations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))
          }).length !== 0) {
            selectedContextIsEmpty = false
          }
        }
        if (filters.includes("Translated by DeepL")) {
          if (selectedContextMessages.filter((message: any, index: any) => {
            return message.innerHTML === "Translated by DeepL" && (selectedContextSources[index].innerHTML.toLowerCase().includes(search.toLowerCase()) || selectedContextTranslations[index].innerHTML.toLowerCase().includes(search.toLowerCase()))
          }).length !== 0) {
            selectedContextIsEmpty = false
          }
        }
        
        if (!selectedContextIsEmpty) {
          newNonEmptyContexts.push(selectedContext)
        }
      }
    }
    setNonEmptyContexts(newNonEmptyContexts)

    if (newFilteredTranslations.length > 0) {
      setCurrentTranslation(newFilteredTranslations.at(0).innerHTML)
      setCurrentTranslations(newFilteredTranslations.map(translation => translation.innerHTML))
      setFieldType(newFilteredTranslations.at(0).getAttribute("type") !== null ? "unfinished" : (newFilteredMessages.at(0).innerHTML.includes("DeepL") ? "unverified" : "done"))
      setFieldTypes(newFilteredTranslations.map((translation, currentFieldIndex) => translation.getAttribute("type") !== null ? "unfinished" : (newFilteredMessages.at(currentFieldIndex).innerHTML.includes("DeepL") ? "unverified" : "done")))
      setAutoTranslateFilePressed(false)

      // [S.S.] Updating the field index and the current context with the right values
      if (newNonEmptyContexts.length !== 0 && !newNonEmptyContexts.includes(currentContext)) {
        setCurrentContext(newNonEmptyContexts[0])
        setPreviousContext(selectedContexts[0])
        setFieldIndex(0)
      } else if (!selectedContexts.includes(currentContext) && selectedContexts[0] !== "") {
        setCurrentContext(selectedContexts[0])
        setPreviousContext(selectedContexts[0])
        setFieldIndex(0)
      } else if (previousContext !== currentContext && selectedContexts.indexOf(currentContext) < selectedContexts.indexOf(previousContext)) {
        // [S.S.] Context was changed when going to the previous field
        // Setting the value for the field index to be the last element in the previous context
        setCurrentTranslation(newFilteredTranslations.at(newFilteredTranslations.length - 1).innerHTML)
        setFieldType(newFilteredTranslations.at(newFilteredTranslations.length - 1).getAttribute("type") !== null ? "unfinished" : (newFilteredMessages.at(newFilteredMessages.length - 1).innerHTML.includes("DeepL") ? "unverified" : "done"))
        setFieldIndex(newFilteredTranslations.length - 1)
        setPreviousContext(currentContext)
      } else {
        setFieldIndex(0)
      }
    } else {
      if (newNonEmptyContexts.length !== 0 && !newNonEmptyContexts.includes(currentContext)) {
        setCurrentContext(newNonEmptyContexts[0])
        setPreviousContext(selectedContexts[0])
        setFieldIndex(0)
      } else {
        setCurrentTranslation("")
        setCurrentTranslations([])
        setFieldType("unfinished")
        setFieldTypes([])
        setFieldIndex(-1)
      }
    }

    setFindItemReady(true)
  }

  const getUnfinishedItems = () => {
    let unfinishedItems: any = {}
    let emptyFields: any = {}
    let emptyFieldsCounter: number = 0

    let selectedContexts = contextFilter.split(';')
    if (contexts) {
      for (let selectedContext of selectedContexts) {
        if (filteredItems[selectedContext].indexes.length !== 0) {
          emptyFieldsCounter += filteredItems[selectedContext].indexes.reduce((accumulator: number, indexValue: number, index: number) => {
            if (filteredItems[selectedContext].translations[index].getAttribute("type") !== null || filteredItems[selectedContext].messages[index].innerHTML.includes("DeepL")) {
              if (emptyFields[selectedContext] === undefined) {
                emptyFields[selectedContext] = {
                  indexes: [],
                  sources: []
                }
              }
              emptyFields[selectedContext].indexes.push(indexValue)
              emptyFields[selectedContext].sources.push(filteredItems[selectedContext].sources[index].innerHTML)
              accumulator += 1
            }
            return accumulator
          }, 0)
        }
      }
    }
    unfinishedItems["fields"] = emptyFields
    unfinishedItems["counter"] = emptyFieldsCounter
    return unfinishedItems
  }

  const goToNextUnfinishedItem = (filteredItems: any, unfinishedItems: any, currentFieldIndex: number, currentContext: string) => {
    let nextFieldIndex = currentFieldIndex
    let nextContext = currentContext
    let selectedContexts = contextFilter.split(';')

    if (contexts && unfinishedItems.counter > 1) {
      if (currentFieldIndex >= unfinishedItems.fields[currentContext].indexes[unfinishedItems.fields[currentContext].indexes.length - 1]) {
        nextContext = selectedContexts[selectedContexts.indexOf(currentContext) + 1] || selectedContexts[0]
        nextFieldIndex = unfinishedItems.fields[nextContext].indexes[0]
      } else {
        nextContext = currentContext
        for (let index of unfinishedItems.fields[currentContext].indexes) {
          if (index > currentFieldIndex) {
            nextFieldIndex = index
            break
          }
        }
      }
    }

    setCurrentContext(nextContext)
    setPreviousContext(nextContext)
    setFieldIndex(nextFieldIndex)
    setSources(contexts[nextContext].sources)
    setTranslations(contexts[nextContext].translations)
    setMessages(contexts[nextContext].messages)
    setCurrentTranslation(filteredItems[nextContext].translations[nextFieldIndex].innerHTML)
    setFieldType(filteredItems[nextContext].translations[nextFieldIndex].getAttribute("type") !== null ? "unfinished" : (filteredItems[nextContext].messages[nextFieldIndex].innerHTML.includes("DeepL") ? "unverified" : "done"))
  }

  const onChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearch = event.target.value
    setSearch(newSearch)
  }

  // eslint-disable-next-line
  const debouncedSearchSentences = useCallback(debounce(searchSentences, 300), [])

  const ListRowRenderer = ({index, key, style}: {index: number, key: string, style: CSSProperties}) => (
    <div
      style={{
        ...style,
        width: "100%",
        display: "flex",
        gap: ".5em",
        alignItems: "center",
        marginBottom: `${index < filteredSources.length - 1 ? ".5em" : "0"}`
      }}
      key={key}
    >
      <Tooltip title={filteredSources.length === 0 ? "" : filteredSources.at(index).innerHTML}>
        <TextField
          sx={{
            flexGrow: "1",
            "& .MuiInputBase-input": {
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          }}
          disabled={contextFilter === "None" || filteredSources.length === 0}
          value={filteredSources.length === 0 ? "" : filteredSources.at(index).innerHTML}
          InputProps={{
            readOnly: true
          }}
        />
      </Tooltip>
      <Tooltip title={filteredSources.length === 0 ? "" : filteredTranslations.at(index).innerHTML}>
        <TextField
          sx={{
            flexGrow: "1",
            "& .MuiInputBase-input": {
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          }}
          disabled={contextFilter === "None" || filteredTranslations.length === 0}
          value={currentTranslations[index] || ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            let newCurrentTranslations = [...currentTranslations]
            newCurrentTranslations[index] = event.target.value
            setCurrentTranslations(newCurrentTranslations)
            filteredTranslations[index].innerHTML = event.target.value
            filteredTranslations[index].setAttribute("type", "unfinished")
            filteredMessages[index].innerHTML = `Translated by ${user!.displayName}`

            // [S.S.] if current value is different than the initial translation, add the new to the initialItems object
            let fieldContext = filteredSources[index].parentNode.parentNode.firstElementChild.innerHTML
            let newInitialItems: any = Object.assign({}, initialItems)
            for (let [itemIndex, item] of newInitialItems[fieldContext].entries()) {
              if (item.source === filteredSources[index].innerHTML) {
                if (event.target.value === item.initialTranslation) {
                  delete item.newTranslation
                } else {
                  item.newTranslation = event.target.value
                }

                if (user!.displayName === item.initialTranslator) {
                  delete item.newTranslator
                } else {
                  item.newTranslator = user!.displayName
                }

                if (item.initialState === "unfinished") {
                  delete item.newState
                } else {
                  item.newState = "unfinished"
                }
                newInitialItems[fieldContext][itemIndex] = item
                break
              }
            }
            let newFieldTypes = [...fieldTypes]
            newFieldTypes[index] = "unfinished"
            setFieldTypes(newFieldTypes)
            setInitialItems(newInitialItems)
          }}
        />
      </Tooltip>
      <Tooltip title={filteredSources.length === 0 ? "" : `Mark ${fieldTypes[index] === "done" ? "unfinished" : "done"}`}>
        <IconButton
          disabled={filteredSources.length === 0}
          onClick={() => {
            // [S.S.] Since we no longer have a single context in the list,
            // We need to figure out what the context of the selected field was.
            let fieldContext = filteredSources[index].parentNode.parentNode.firstElementChild.innerHTML

            if (filteredTranslations[index].getAttribute("type") === null && fieldTypes[index] !== "unverified") {
              filteredTranslations[index].setAttribute("type", "unfinished")
              filteredMessages[index].innerHTML = `Translated by ${user!.displayName}`
              let newFieldTypes = [...fieldTypes]
              newFieldTypes[index] = "unfinished"
              setFieldTypes(newFieldTypes)
              // if current state is different than the initial state, add the new state to the initialItems object
              let newInitialItems: any = Object.assign({}, initialItems)
              for (let [itemIndex, item] of newInitialItems[fieldContext].entries()) {
                if (item.source === filteredSources[index].innerHTML) {
                  if (item.initialState === "unfinished") {
                    delete item.newState
                  } else {
                    item.newState = "unfinished"
                  }

                  if (user!.displayName === item.initialTranslator) {
                    delete item.newTranslator
                  } else {
                    item.newTranslator = user!.displayName
                  }
                  newInitialItems[fieldContext][itemIndex] = item
                  break
                }
              }
              setInitialItems(newInitialItems)
            } else {
              filteredTranslations[index].removeAttribute("type")
              filteredMessages[index].innerHTML = `Translated by ${user!.displayName}`
              let newFieldTypes = [...fieldTypes]
              newFieldTypes[index] = "done"
              setFieldTypes(newFieldTypes)
              // if current state is different than the initial state, add the new state to the initialItems object
              let newInitialItems: any = Object.assign({}, initialItems)
              for (let [itemIndex, item] of newInitialItems[fieldContext].entries()) {
                if (item.source === filteredSources[index].innerHTML) {
                  if (item.initialState === "done") {
                    delete item.newState
                  } else {
                    item.newState = "done"
                  }

                  if (user!.displayName === item.initialTranslator) {
                    delete item.newTranslator
                  } else {
                    item.newTranslator = user!.displayName
                  }
                  newInitialItems[fieldContext][itemIndex] = item
                  break
                }
              }
              setInitialItems(newInitialItems)
            }
          }}
        >
          {
            fieldTypes[index] === "done" ?
              <CheckCircleOutlineRounded color="primary" />
            : fieldTypes[index] === "unverified" ?
              <CheckCircleOutlineRounded sx={{ color: "orange" }} />
            : currentTranslations[index] === "" ?
              <RadioButtonUncheckedRounded />
            :
              <HelpOutlineRounded />
          }
        </IconButton>
      </Tooltip>
      <Tooltip title={filteredSources.length === 0 ? "" : "Jump to field"}>
        <IconButton
          disabled={filteredSources.length === 0}
          onClick={() => {
            if ((fieldTypes[index] === "done"       && !/Translated;|Translated$/.test(sentenceStateFilter)) ||
                (fieldTypes[index] === "unfinished" && !sentenceStateFilter.includes("Unfinished"))          ||
                (fieldTypes[index] === "unverified" && !sentenceStateFilter.includes("Translated by DeepL")))
            {
              /* WEB-221 Crash when jumping from list to translation item:
               * Triggered when the state has changed but the new state is not a filter factor.
               */
              setOpenItemNotOnListDialog(true);
              return;
            }
            // [S.S.] Since we no longer have a single context in the list,
            // We need to figure out what the context of the selected field was.
            let fieldContext = filteredSources[index].parentNode.parentNode.firstElementChild.innerHTML
            setFindSource(filteredSources[index])
            setFindItemReady(false)
            setDisplayMode("items")
            // [S.S.] Setting sources, translations and messages of the selected field's context in items view
            setCurrentContext(fieldContext)
            setPreviousContext(fieldContext)
            setSources(contexts[fieldContext].sources)
            setTranslations(contexts[fieldContext].translations)
            setMessages(contexts[fieldContext].messages)
          }}
        >
          <ReplyRounded color={ (fieldTypes[index] === "done"       && !/Translated;|Translated$/.test(sentenceStateFilter)) ||
                                (fieldTypes[index] === "unfinished" && !sentenceStateFilter.includes("Unfinished"))          ||
                                (fieldTypes[index] === "unverified" && !sentenceStateFilter.includes("Translated by DeepL")) ? 'error' : 'action'}/>
        </IconButton>
      </Tooltip>
    </div>
  )

  const handleFileContentReceived = function (data: any) {
    if (data.error) {
      makeToast("error", data.error, mode)
    } else {
      const text = data.fileContent || ""
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(`${text}`, 'text/xml')
      setFileContent(xmlDoc)
      const availableContexts = [...xmlDoc.getElementsByTagName("context")]
      let contextsChildren: any[] = []
      const newContextsNames = availableContexts.map(context => {
        const contextChildren = [...context.children]
        const contextName = contextChildren.shift()!.innerHTML
        contextsChildren.push(contextChildren)
        return contextName
      })
      setContextsNames(newContextsNames)
      if (newContextsNames[0]) {
        setContextFilter(newContextsNames.join(';'))
      } else {
        setContextFilter("None")
        setCurrentTranslation("")
        setCurrentTranslations([])
        setContexts(undefined)
        setContextsNames([])
        setFieldIndex(-1)
        setSources([])
        setTranslations([])
        setMessages([])
        setFilteredSources([])
        setFilteredTranslations([])
        setFilteredMessages([])
        setFieldType("unfinished")
        setFieldTypes([])
        return
      }
      let newContexts: any = {}
      let newInitialItems: any = {}
      for (let [index, contextName] of newContextsNames.entries()) {
        let currentContextSources: any[] = []
        let currentContextTranslations: any[] = []
        let currentContextMessages: any[] = []
        let currentContextStates: any[] = []
        for (let contextMessage of contextsChildren.at(index)) {
          let newSource = [...contextMessage.children].filter(element => element.tagName === "source")
          currentContextSources = [...currentContextSources, ...newSource]
          let newTranslation = [...contextMessage.children].filter(element => element.tagName === "translation")
          currentContextTranslations = [...currentContextTranslations, ...newTranslation]
          if (contextMessage.getElementsByTagName("translatorcomment").length === 0) {
            const element = xmlDoc.createElement("translatorcomment")
            contextMessage.appendChild(element)
            currentContextMessages = [...currentContextMessages, element]
          } else {
            currentContextMessages = [...currentContextMessages, contextMessage.getElementsByTagName("translatorcomment").item(0)]
          }
          let newState = newTranslation.at(0).getAttribute('type')! !== null ? "unfinished" : ((contextMessage.getElementsByTagName("translatorcomment").length !== 0 && contextMessage.getElementsByTagName("translatorcomment").item(0).innerHTML.includes("DeepL")) ? "unverified" : "done")
          currentContextStates = [...currentContextStates, newState]
        }
        const contextData = {
          sources: currentContextSources,
          translations: currentContextTranslations,
          messages: currentContextMessages
        }
        const contextInitialItems = {
          sources: currentContextSources.map(source => source.innerHTML),
          translations: currentContextTranslations.map(translation => translation.innerHTML),
          states: currentContextStates,
          translators: currentContextMessages.map(message => message.innerHTML.split(' ').slice(2).join(' '))
        }
        newContexts[contextName] = contextData
        newInitialItems[contextName] = []
        for (let [index, source] of contextInitialItems.sources.entries()) {
          let itemProperties = {
            source: source,
            initialTranslation: contextInitialItems.translations[index],
            initialState: contextInitialItems.states[index],
            initialTranslator: contextInitialItems.translators[index]
          }
          newInitialItems[contextName].push(itemProperties)
        }
      }
      setContexts(newContexts)
      setCurrentContext(newContextsNames[0])
      setPreviousContext(newContextsNames[0])
      setInitialItems(newInitialItems)
      setSources(newContexts[newContextsNames[0]].sources)
      setTranslations(newContexts[newContextsNames[0]].translations)
      setMessages(newContexts[newContextsNames[0]].messages)
      setFieldIndex(0)
      setAutoTranslationSupported(data.autoTranslationSupported)
      setHistory(data.history.reverse())
    }
  }

  useEffect(() => {
    socket.on("save_file_content_status", (data) => {
      if (fileClosed) {
        setContextFilter("None")
        setContexts(undefined)
        setContextsNames([])
        setFieldIndex(-1)
        setSources([])
        setTranslations([])
        setMessages([])
        setCurrentTranslation("")
        setCurrentTranslations([])
        setFileContent(undefined)
        setSelectedFilesCategory("")
        setSelectedTranslationFilesCategory("")
        setSelectedTranslationFile("")
        setFieldType("unfinished")
        setFieldTypes([])
        setAutoTranslationSupported(false)
        setHistory([])
        setInitialItems({})
        setFileClosed(false)
      } else if (data.status === "success") {
        let newInitialItems: any = {}
        for (const contextName of Object.keys(initialItems)) {
          newInitialItems[contextName] = []
          for (const item of initialItems[contextName]) {
            if (item.newTranslation !== undefined) {
              item.initialTranslation = item.newTranslation
              delete item.newTranslation
            }
            if (item.newState !== undefined) {
              item.initialState = item.newState
              delete item.newState
            }
            if (item.newTranslator !== undefined) {
              item.initialTranslator = item.newTranslator
              delete item.newTranslator
            }
            newInitialItems[contextName].push(item)
          }
        }
        setInitialItems(newInitialItems)
      }
      makeToast(data.status, data.message, mode)
    })

    return () => {
      socket.off("save_file_content_status")
    }
    // eslint-disable-next-line
  }, [mode, contexts, fileClosed])

  useEffect(() => {
    socket.on("file_content_received", handleFileContentReceived)
    
    socket.on('translated_fields_received', (data) => {
      setAutoTranslateFileLoading(false)
      if (data.status === "error") {
        makeToast(data.status, data.message, mode)
      } else {
        const translatedFields = data.translatedFields
        let newInitialItems: any = Object.assign({}, initialItems)
        let newFieldTypes = [...fieldTypes]
        let newCurrentTranslations = [...currentTranslations]
        let newCurrentTranslation: string = ""
        for (const contextKey of Object.keys(translatedFields)) {
          for (const [index, translationFieldIndex] of translatedFields[contextKey].indexes.entries()) {
            newCurrentTranslations[translationFieldIndex] = translatedFields[contextKey].translations[index]
            contexts[contextKey].translations[translationFieldIndex].innerHTML = translatedFields[contextKey].translations[index]
            contexts[contextKey].translations[translationFieldIndex].removeAttribute("type")
            contexts[contextKey].messages[translationFieldIndex].innerHTML = "Translated by DeepL"
            newFieldTypes[translationFieldIndex] = "unverified"

            // if current state is different than the initial state, add the new state to the initialItems object
            let item: any = newInitialItems[contextKey][translationFieldIndex]
            if (item.initialState === "unverified") {
              delete item.newState
            } else {
              item.newState = "unverified"
            }

            if (item.initialTranslator === "DeepL") {
              delete item.newTranslator
            } else {
              item.newTranslator = "DeepL"
            }
            newInitialItems[contextKey][translationFieldIndex] = item
            if (contextKey === contextFilter && translationFieldIndex === fieldIndex) {
              newCurrentTranslation = translatedFields[contextKey].translations[index]
            }

            // Adding the new translation value to the initialItems object
            if (initialItems[contextKey][translationFieldIndex].initialTranslation !== translatedFields[contextKey].translations[index]) {
              newInitialItems[contextKey][translationFieldIndex].newTranslation = translatedFields[contextKey].translations[index]
            }
          }
        }
        setFieldType("unverified")
        setFieldTypes(newFieldTypes)
        setInitialItems(newInitialItems)
        setCurrentTranslation(newCurrentTranslation)
        setCurrentTranslations(newCurrentTranslations)
        setAutoTranslateFilePressed(true)
      }
    })

    return () => {
      socket.off("file_content_received", handleFileContentReceived)
      socket.off("translated_fields_received")
    }
    // eslint-disable-next-line
  }, [mode, contexts, contextFilter, fieldIndex, filteredSources, filteredTranslations, sentenceStateFilter, initialItems, fieldTypes])

  useEffect(() => {
    socket.on("auto_translation_received", (data) => {
      setAutoTranslateFieldLoading(false)
      if (data.status === "error") {
        makeToast(data.status, data.message, mode)
      } else {
        setCurrentTranslation(data.translation)
        filteredTranslations[fieldIndex].innerHTML = data.translation
        filteredMessages[fieldIndex].innerHTML = "Translated by DeepL"

        if (filteredTranslations[fieldIndex].getAttribute("type") !== null) {
          filteredTranslations[fieldIndex].removeAttribute("type")
        }
        setFieldType("unverified")

        // [S.S.] Iff current state is different than the initial state or the translation is different,
        // add the new state or the new translation to the initialItems object.
        let newInitialItems: any = Object.assign({}, initialItems)
        for (let [index, item] of newInitialItems[currentContext].entries()) {
          if (item.source === filteredSources[fieldIndex].innerHTML) {
            if (item.initialState === "unverified") {
              delete item.newState
            } else {
              item.newState = "unverified"
            }

            if (item.initialTranslator === "DeepL") {
              delete item.newTranslator
            } else {
              item.newTranslator = "DeepL"
            }

            if (data.translation === item.initialTranslation) {
              delete item.newTranslation
            } else {
              item.newTranslation = data.translation
            }
            newInitialItems[currentContext][index] = item
            break
          }
        }
        setInitialItems(newInitialItems)
      }
    })

    return () => {
      socket.off("auto_translation_received")
    }
    // eslint-disable-next-line
  }, [mode, fieldIndex, filteredTranslations, filteredMessages, currentContext])

  useEffect(() => {
    socket.on("history_updated", (data) => {
      setClearHistoryLoading(false)
      if (data.fileName === selectedTranslationFile) {
        setHistory(data.history.reverse())
      }
    })

    return () => {
      socket.off("history_updated")
    }
  }, [mode, selectedTranslationFile])

  useEffect(() => {
    debouncedSearchSentences(search, sentenceStateFilter, sources, translations, messages, previousContext, currentContext, contextFilter, contexts, displayMode)

    return () => {
      debouncedSearchSentences.cancel()
    }

    // eslint-disable-next-line
  }, [search, sources, messages, sentenceStateFilter, currentContext, contextFilter, contexts, autoTranslateFilePressed, displayMode, refreshPressed])

  useEffect(() => {
    if (contextFilter !== "None") {
      if (displayMode === "items") {
        setSources(contexts[currentContext].sources)
        setTranslations(contexts[currentContext].translations)
        setMessages(contexts[currentContext].messages)
      } else {
        let newSources: any[] = []
        let newTranslations: any[] = []
        let newMessages: any[] = []
        let selectedContexts = contextFilter.split(';')
        for (let selectedContext of selectedContexts) {
          newSources = [...newSources, ...contexts[selectedContext].sources]
          newTranslations = [...newTranslations, ...contexts[selectedContext].translations]
          newMessages = [...newMessages, ...contexts[selectedContext].messages]
        }
        setSources(newSources)
        setTranslations(newTranslations)
        setMessages(newMessages)
      }
    }
    // eslint-disable-next-line
  }, [contextFilter, contexts, displayMode, findSource, currentContext])

  useEffect(() => {
    socket.on("translation_file_modified", (data: any) => {
      if (data.fileName === selectedTranslationFile) {
        setDialogOpen(true)
      }
    })
    return () => {
      socket.off("translation_file_modified")
    }
    // eslint-disable-next-line
  }, [selectedTranslationFilesCategory, selectedTranslationFile])

  useEffect(() => {
    let newTranslationFilesCategories = []
    let newAvailableFirmwareVersions = []
    if (currentRole === "Global Administrator") {
      newAvailableFirmwareVersions.push("FW2")
      newAvailableFirmwareVersions.push("FW3")
    } else {
      let fw2FilesAvailable = false
      let fw3FilesAvailable = false
      if (user!.availableSpeechTranslationFiles !== "") {
        for (let file of user!.availableSpeechTranslationFiles.split(';')) {
          if (file.includes("fw3")) {
            fw3FilesAvailable = true
          } else {
            fw2FilesAvailable = true
          }
        }
      }
      if (user!.availableWebInterfaceTranslationFiles !== "") {
        for (let file of user!.availableWebInterfaceTranslationFiles.split(';')) {
          if (file.includes("fw3")) {
            fw3FilesAvailable = true
          } else {
            fw2FilesAvailable = true
          }
        }
      }
      if (fw2FilesAvailable) {
        newAvailableFirmwareVersions.push("FW2")
      }
      if (fw3FilesAvailable) {
        newAvailableFirmwareVersions.push("FW3")
      }
    }

    if (newAvailableFirmwareVersions[0] === "FW2") {
      let speechFilesAvailable = false
      let webInterfaceFilesAvailable = false
      if (user!.availableSpeechTranslationFiles !== "") {
        for (let file of user!.availableSpeechTranslationFiles.split(';')) {
          if (!file.includes("fw3")) {
            speechFilesAvailable = true
            break
          }
        }
      }
      if (user!.availableWebInterfaceTranslationFiles !== "") {
        for (let file of user!.availableWebInterfaceTranslationFiles.split(';')) {
          if (!file.includes("fw3")) {
            webInterfaceFilesAvailable = true
            break
          }
        }
      }
      if (speechFilesAvailable || currentRole === "Global Administrator") {
        newTranslationFilesCategories.push("Speech")
      }
      if (webInterfaceFilesAvailable || currentRole === "Global Administrator") {
        newTranslationFilesCategories.push("Web Interface")
      }
    }
    if (newAvailableFirmwareVersions[0] === "FW3") {
      let speechFilesAvailable = false
      let webInterfaceFilesAvailable = false
      if (user!.availableSpeechTranslationFiles !== "") {
        for (let file of user!.availableSpeechTranslationFiles.split(';')) {
          if (file.includes("fw3")) {
            speechFilesAvailable = true
            break
          }
        }
      }
      if (user!.availableWebInterfaceTranslationFiles !== "") {
        for (let file of user!.availableWebInterfaceTranslationFiles.split(';')) {
          if (file.includes("fw3")) {
            webInterfaceFilesAvailable = true
            break
          }
        }
      }
      if (speechFilesAvailable || currentRole === "Global Administrator") {
        newTranslationFilesCategories.push("Speech")
      }
      if (webInterfaceFilesAvailable || currentRole === "Global Administrator") {
        newTranslationFilesCategories.push("Web Interface")
      }
    }

    setAvailableFirmwareVersions(newAvailableFirmwareVersions)
    setSelectedFirmwareVersion(newAvailableFirmwareVersions[0])

    setAvailableTranslationFilesCategories(newTranslationFilesCategories)
    if (!newTranslationFilesCategories.includes(selectedTranslationFilesCategory)) {
      setSelectedTranslationFilesCategory("")
    }
    // eslint-disable-next-line
  }, [user!.availableSpeechTranslationFiles, user!.availableWebInterfaceTranslationFiles, currentRole])

  useEffect(() => {
    localStorage.setItem("translationFileFieldsDisplayMode", JSON.stringify(displayMode))
  }, [displayMode])

  useEffect(() => {
    if (findSource !== "" && findItemReady) {
      let newFieldIndex = filteredSources.findIndex(source => source === findSource)
      setFieldIndex(newFieldIndex)
      setCurrentTranslation(filteredTranslations[newFieldIndex].innerHTML)
      setFieldType(filteredTranslations[newFieldIndex].getAttribute("type") !== null ? "unfinished" : (filteredMessages[newFieldIndex].innerHTML.includes("DeepL") ? "unverified" : "done"))
      setFindSource("")
      setFindItemReady(false)
    }
  }, [findSource, findItemReady, filteredSources, filteredTranslations, filteredMessages])

  return (
    <Navigation
      title={title}
      actions={
        <>
          <IconButton
            size="large"
            role="button"
            aria-labelledby="account of current user"
            aria-describedby="open the account page of the current user"
            color="inherit"
            edge="end"
            onClick={() => navigate('/account')}
          >
            <AccountCircleRounded />
          </IconButton>
        </>
      }
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          my={2}
          sx={{
            width: "100%",
            textAlign: "left",
            paddingInline: ".5em"
          }}
        >
          Translation
        </Typography>
        <Box
          sx={{
            paddingInline: "1em",
            marginBlock: "1em",
            display: "flex",
            flexDirection: "column",
            gap: "1em"
          }}
        >
          <Box
            className={classes.translationCard}
            sx={{
              width: "100% !important"
            }}
          >
            <div
              style={{
                display: "flex",
                width: "auto",
                alignItems: "flex-end"
              }}
            >
              <p
                style={{
                  fontSize: "1.5em",
                  marginRight: ".5em"
                }}
              >
                File
              </p>
              <p
                style={{
                  paddingBottom: ".2em",
                  color: `${mode === "light" ? "#25252580" : "#FFFFFF80"}`
                }}
              >
                {sources.length !== 0 ? selectedTranslationFile : "None"}
              </p>
            </div>
            <p
              style={{
                fontSize: "1.5em",
                marginTop: ".5em",
              }}
            >
              Search
            </p>
            <Tooltip title={`Search: "${search}"`}>
              <TextField
                sx={{
                  width: "100%"
                }}
                role="search"
                aria-labelledby="search box"
                aria-describedby="a search box to search for sentences"
                disabled={contextFilter === "None"}
                value={search}
                onChange={onChangeSearch}
              />
            </Tooltip>
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "auto",
                alignItems: "flex-end",
                justifyContent: "space-between"
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "auto",
                  marginTop: "1em",
                  alignItems: "flex-end"
                }}
              >
                <p
                  style={{
                    fontSize: "1.5em",
                    marginRight: ".5em"
                  }}
                >
                  Items
                </p>
                <p
                  style={{
                    paddingBottom: ".2em",
                    color: `${mode === "light" ? "#25252580" : "#FFFFFF80"}`
                  }}
                >
                  {`${filteredSources.length} ${filteredSources.length === 1 ? "result" : "results"} ${displayMode === "items" && sources.length !== 0 ? "[" + currentContext + "]" : ""}`}
                </p>
              </div>
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: ".25em"
                }}
              >
                {
                  displayMode === "list" &&
                    <>
                      <Tooltip title={sources.length === 0 ? "" : "Compress items list"}>
                        <IconButton
                          sx={{
                            width: "50px",
                            height: "50px",
                          }}
                          disabled={sources.length === 0}
                          onClick={() => {
                            if (listViewBoxSize > 200) {
                              setListViewBoxSize(listViewBoxSize - 75)
                            }
                          }}
                        >
                          <CompressRounded />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={sources.length === 0 ? "" : "Expand items list"}>
                        <IconButton
                          sx={{
                            width: "50px",
                            height: "50px",
                          }}
                          disabled={sources.length === 0}
                          onClick={() => {
                            if (listViewBoxSize < 650) {
                              setListViewBoxSize(listViewBoxSize + 75)
                            }
                          }}
                        >
                          <ExpandRounded />
                        </IconButton>
                      </Tooltip>
                    </>
                }
                <Tooltip title={sources.length === 0 ? "" : `View as ${displayMode === "list" ? "items" : "list"}`}>
                  <IconButton
                    sx={{
                      width: "50px",
                      height: "50px",
                    }}
                    aria-hidden={true}
                    tabIndex={-1}
                    disabled={sources.length === 0}
                    onClick={() => {
                      if (displayMode === "items") {
                        setDisplayMode("list")
                        // [S.S.] Setting sources, translations and messages of all selected contexts
                        let newSources: any[] = []
                        let newTranslations: any[] = []
                        let newMessages: any[] = []
                        let selectedContexts = contextFilter.split(';')
                        for (let selectedContext of selectedContexts) {
                          newSources = [...newSources, ...contexts[selectedContext].sources]
                          newTranslations = [...newTranslations, ...contexts[selectedContext].translations]
                          newMessages = [...newMessages, ...contexts[selectedContext].messages]
                        }
                        setSources(newSources)
                        setTranslations(newTranslations)
                        setMessages(newMessages)
                      } else {
                        setDisplayMode("items")
                        // [S.S.] Setting sources, translations and messages of the previously selected context in items view
                        let selectedContexts = contextFilter.split(';')
                        let newCurrentContext = selectedContexts[0]
                        setCurrentContext(newCurrentContext)
                        setPreviousContext(newCurrentContext)
                        setSources(contexts[newCurrentContext].sources)
                        setTranslations(contexts[newCurrentContext].translations)
                        setMessages(contexts[newCurrentContext].messages)
                      }
                    }}
                  >
                    {displayMode === "items" ? <FormatListBulletedRounded /> : <WrapTextRounded />}
                  </IconButton>
                </Tooltip>
                <Tooltip title={sources.length === 0 ? "" : "Filter"}>
                  <IconButton
                    disabled={sources.length === 0}
                    role="button"
                    aria-labelledby="filter"
                    aria-describedby="open filters modal"
                    sx={{
                      width: "50px",
                      height: "50px"
                    }}
                    onClick={() => {
                      setModalOpen(true)
                    }}
                  >
                    <FilterAltRounded />
                  </IconButton>
                </Tooltip>
                <Tooltip title={sources.length === 0 ? "" : "Refresh list"}>
                  <IconButton
                    disabled={sources.length === 0}
                    role="button"
                    aria-labelledby="refresh"
                    aria-describedby="refresh list items"
                    sx={{
                      width: "50px",
                      height: "50px"
                    }}
                    onClick={() => {
                      setRefreshPressed(!refreshPressed);
                    }}
                  >
                    <RefreshRounded />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <Box className={classes.translationCardItemsBox}>
              {
                displayMode === "items" ?
                  <>
                    <p
                      style={{
                        fontSize: "1.25em"
                      }}
                    >
                      Source
                    </p>
                    <Tooltip title={filteredSources.length === 0 ? "" : filteredSources.at(fieldIndex).innerHTML}>
                      <TextField
                        key={`source-${fieldIndex + 1}`}
                        minRows={1}
                        maxRows={100}
                        role="textbox"
                        aria-labelledby="source"
                        aria-describedby="default, untranslated sentence, in english"
                        multiline
                        fullWidth
                        disabled={contextFilter === "None" || filteredSources.length === 0}
                        value={filteredSources.length === 0 ? "" : filteredSources.at(fieldIndex).innerHTML}
                        InputProps={{
                          readOnly: true
                        }}
                      />
                    </Tooltip>
                    <p
                      style={{
                        fontSize: "1.25em",
                        marginTop: "1em"
                      }}
                    >
                      Translation
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1em"
                      }}
                    >
                      <Tooltip title={filteredSources.length === 0 ? "" : filteredTranslations.at(fieldIndex).innerHTML}>
                        <TextField
                          key={`translation-${fieldIndex + 1}`}
                          minRows={1}
                          maxRows={100}
                          role="textbox"
                          aria-labelledby="translation"
                          aria-describedby="sentence translation"
                          multiline
                          fullWidth
                          disabled={contextFilter === "None" || filteredTranslations.length === 0}
                          value={currentTranslation}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setCurrentTranslation(event.target.value)
                            filteredTranslations[fieldIndex].innerHTML = event.target.value
                            filteredTranslations[fieldIndex].setAttribute("type", "unfinished")
                            filteredMessages[fieldIndex].innerHTML = `Translated by ${user!.displayName}`
                            // if current value is different than the initial translation, add the new to the initialItems object
                            let newInitialItems: any = Object.assign({}, initialItems)
                            for (let [index, item] of newInitialItems[currentContext].entries()) {
                              if (item.source === filteredSources[fieldIndex].innerHTML) {
                                if (event.target.value === item.initialTranslation) {
                                  delete item.newTranslation
                                } else {
                                  item.newTranslation = event.target.value
                                }

                                if (user!.displayName === item.initialTranslator) {
                                  delete item.newTranslator
                                } else {
                                  item.newTranslator = user!.displayName
                                }

                                if (item.initialState === "unfinished") {
                                  delete item.newState
                                } else {
                                  item.newState = "unfinished"
                                }
                                newInitialItems[currentContext][index] = item
                                break
                              }
                            }
                            setFieldType("unfinished")
                            setInitialItems(newInitialItems)
                          }}
                        />
                      </Tooltip>
                      <Tooltip title={filteredSources.length === 0 ? "" : `Mark ${fieldType === "done" ? "unfinished" : "done"}`}>
                        <IconButton
                          disabled={filteredSources.length === 0}
                          role="button"
                          aria-labelledby={`mark ${fieldType === "done" ? "unfinished" : "done"}`}
                          aria-describedby="button for marking the state of the current sentence"
                          onClick={() => {
                            if (filteredTranslations[fieldIndex].getAttribute("type") === null && fieldType !== "unverified") {
                              filteredTranslations[fieldIndex].setAttribute("type", "unfinished")
                              filteredMessages[fieldIndex].innerHTML = `Translated by ${user!.displayName}`
                              setFieldType("unfinished")
                              // if current state is different than the initial state, add the new state to the initialItems object
                              let newInitialItems: any = Object.assign({}, initialItems)
                              for (let [index, item] of newInitialItems[currentContext].entries()) {
                                if (item.source === filteredSources[fieldIndex].innerHTML) {
                                  if (item.initialState === "unfinished") {
                                    delete item.newState
                                  } else {
                                    item.newState = "unfinished"
                                  }

                                  if (user!.displayName === item.initialTranslator) {
                                    delete item.newTranslator
                                  } else {
                                    item.newTranslator = user!.displayName
                                  }
                                  newInitialItems[currentContext][index] = item
                                  break
                                }
                              }
                              setInitialItems(newInitialItems)
                            } else {
                              filteredTranslations[fieldIndex].removeAttribute("type")
                              filteredMessages[fieldIndex].innerHTML = `Translated by ${user!.displayName}`
                              setFieldType("done")
                              // if current state is different than the initial state, add the new state to the initialItems object
                              let newInitialItems: any = Object.assign({}, initialItems)
                              for (let [index, item] of newInitialItems[currentContext].entries()) {
                                if (item.source === filteredSources[fieldIndex].innerHTML) {
                                  if (item.initialState === "done") {
                                    delete item.newState
                                  } else {
                                    item.newState = "done"
                                  }

                                  if (user!.displayName === item.initialTranslator) {
                                    delete item.newTranslator
                                  } else {
                                    item.newTranslator = user!.displayName
                                  }
                                  newInitialItems[currentContext][index] = item
                                  break
                                }
                              }
                              setInitialItems(newInitialItems)
                            }
                          }}
                        >
                          {
                            fieldType === "done" ?
                              <CheckCircleOutlineRounded color="primary" />
                            : fieldType === "unverified" ?
                              <CheckCircleOutlineRounded sx={{ color: "orange" }} />
                            : currentTranslation === "" ?
                              <RadioButtonUncheckedRounded />
                            :
                              <HelpOutlineRounded />
                          }
                        </IconButton>
                      </Tooltip>
                    </div>
                    <p
                      style={{
                        fontSize: "1.25em",
                        marginTop: "1em"
                      }}
                    >
                      Translator Message
                    </p>
                    <Tooltip title={filteredSources.length === 0 ? "" : filteredMessages.at(fieldIndex).innerHTML}>
                      <TextField
                        sx={{
                          width: "100%"
                        }}
                        role="textbox"
                        aria-labelledby="translator message"
                        aria-describedby="informations about latest user that modified the status or the translation of the current sentence"
                        disabled={contextFilter === "None" || filteredMessages.length === 0}
                        value={filteredSources.length === 0 ? "" : filteredMessages.at(fieldIndex).innerHTML}
                        InputProps={{
                          readOnly: true
                        }}
                      />
                    </Tooltip>
                  </>
                :
                  <>
                    <div
                      style={{
                        width: "100%",
                        display: "flex"
                      }}
                    >
                      <p
                        style={{
                          fontSize: "1.25em",
                          paddingLeft: "1em",
                          width: "calc(50% - 1em - 20px)",
                          overflow: "hidden",
                          textOverflow: "ellipsis"

                        }}
                      >
                        Source
                      </p>
                      <p
                        style={{
                          fontSize: "1.25em",
                          width: "50%",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                        Translation
                      </p>
                    </div>
                    <Box
                      className={classes.translationCardItemsBoxListViewContainer}
                      sx={{
                        height: `${listViewBoxSize}px !important`
                      }}
                    >
                      {
                        <div style={{ width: "100%", height: "650px" }}>
                          <AutoSizer style={{ width: "100%" }}>
                            {({ height, width }: { height: number, width: number }) => (
                              <List
                                height={height}
                                width={width}
                                rowHeight={65}
                                rowCount={filteredSources.length}
                                rowRenderer={ListRowRenderer}
                                overscanRowCount={5}
                                style={{
                                  paddingRight: ".5em"
                                }}
                              />
                            )}
                          </AutoSizer>
                        </div>
                      }
                    </Box>
                  </>
              }
              {
                displayMode === "items"  &&
                  <div
                    style={{
                      display: "flex",
                      marginTop: "1em",
                      width: "100%",
                      alignItems: "center",
                      gap: ".25em"
                    }}
                  >
                    <Tooltip title={(filteredSources.length === 0) ? "" : "Previous item"}>
                      <IconButton
                        sx={{
                          width: "50px",
                          height: "50px"
                        }}
                        role="button"
                        aria-labelledby="previous item"
                        aria-describedby="move to the previous sentence"
                        disabled={((fieldIndex === -1 || fieldIndex === 0) && contextFilter.includes(';') && currentContext === contextFilter.split(';')[0]) || (nonEmptyContexts.length !== 0 && currentContext === nonEmptyContexts[0] && (fieldIndex === -1 || fieldIndex === 0)) || contextFilter === "None" || !nonEmptyContexts.includes(currentContext)}
                        onClick={() => {
                          if (fieldIndex > 0) {
                            setFieldIndex(fieldIndex - 1)
                            setCurrentTranslation(filteredTranslations[fieldIndex - 1].innerHTML)
                            setFieldType(filteredTranslations[fieldIndex - 1].getAttribute("type") !== null ? "unfinished" : (filteredMessages[fieldIndex - 1].innerHTML.includes("DeepL") ? "unverified" : "done"))
                          } else {
                            let selectedContexts = contextFilter.split(';')
                            if (selectedContexts.indexOf(currentContext) > 0) {
                              let newCurrentContext
                              if (nonEmptyContexts.length !== 0) {
                                newCurrentContext = nonEmptyContexts[Math.max(nonEmptyContexts.indexOf(currentContext) - 1, 0)]
                              } else {
                                newCurrentContext = selectedContexts[selectedContexts.indexOf(currentContext) - 1]
                              }
                              setCurrentContext(newCurrentContext)
                              setSources(contexts[newCurrentContext].sources)
                              setTranslations(contexts[newCurrentContext].translations)
                              setMessages(contexts[newCurrentContext].messages)
                            }
                          }
                        }}
                        size="small"
                        component="label"
                      >
                        <SkipPreviousRounded />
                      </IconButton>
                    </Tooltip>
                    <p
                      tabIndex={0}
                      aria-labelledby="item index"
                      aria-describedby={`field with index ${fieldIndex + 1} in the context ${currentContext}`}
                      style={{
                        fontSize: "1.5em",
                        color: `${filteredSources.length === 0 ? "gray" : mode === "light" ? "rgba(0, 0, 0, 0.54)": "white"}`
                      }}
                    >
                      {`${filteredSources.length === 0 ? "0" : (fieldIndex + 1)}`}
                    </p>
                    <Tooltip title={filteredSources.length === 0 ? "" : "Next item"}>
                      <IconButton
                        sx={{
                          width: "50px",
                          height: "50px"
                        }}
                        role="button"
                        aria-labelledby="next item"
                        aria-describedby="move to the next sentence"
                        disabled={(fieldIndex === filteredSources.length - 1 && contextFilter.includes(';') && currentContext === contextFilter.split(';')[contextFilter.split(';').length - 1]) || (nonEmptyContexts.length !== 0 && currentContext === nonEmptyContexts[nonEmptyContexts.length - 1] && fieldIndex === filteredSources.length - 1) || contextFilter === "None" || !nonEmptyContexts.includes(currentContext)}
                        onClick={() => {
                          if (fieldIndex < filteredSources.length - 1) {
                            setFieldIndex(fieldIndex + 1)
                            setCurrentTranslation(filteredTranslations[fieldIndex + 1].innerHTML)
                            setFieldType(filteredTranslations[fieldIndex + 1].getAttribute("type") !== null ? "unfinished" : (filteredMessages[fieldIndex + 1].innerHTML.includes("DeepL") ? "unverified" : "done"))
                          } else {
                            let selectedContexts = contextFilter.split(';')
                            if (selectedContexts.indexOf(currentContext) < selectedContexts.length - 1) {
                              let newCurrentContext
                              if (nonEmptyContexts.length !== 0) {
                                newCurrentContext = nonEmptyContexts[Math.min(nonEmptyContexts.indexOf(currentContext) + 1, nonEmptyContexts.length - 1)]
                              } else {
                                newCurrentContext = selectedContexts[selectedContexts.indexOf(currentContext) + 1]
                              }
                              setCurrentContext(newCurrentContext)
                              setPreviousContext(newCurrentContext)
                              setFieldIndex(0)
                              setSources(contexts[newCurrentContext].sources)
                              setTranslations(contexts[newCurrentContext].translations)
                              setMessages(contexts[newCurrentContext].messages)
                            }
                          }
                        }}
                        size="small"
                        component="label"
                      >
                        <SkipNextRounded />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={filteredSources.length === 0 ? "" : "Mark item as done and move to the next unfinished item"}>
                      <IconButton
                        sx={{
                          width: "50px",
                          height: "50px"
                        }}
                        role="button"
                        aria-labelledby="next unfinished item"
                        aria-describedby="mark current sentence as done and move to the next unfinished one"
                        disabled={filteredSources.length === 0 || getUnfinishedItems().counter === 0}
                        onClick={() => {
                          let previousUnfinishedItems = getUnfinishedItems()
                          filteredTranslations[fieldIndex].removeAttribute("type")
                          filteredMessages[fieldIndex].innerHTML = `Translated by ${user!.displayName}`
                          let newInitialItems: any = Object.assign({}, initialItems)
                          for (let [index, item] of newInitialItems[currentContext].entries()) {
                            if (item.source === filteredSources[fieldIndex].innerHTML) {
                              if (item.initialState === "done") {
                                delete item.newState
                              } else {
                                item.newState = "done"
                              }

                              if (user!.displayName === item.initialTranslator) {
                                delete item.newTranslator
                              } else {
                                item.newTranslator = user!.displayName
                              }
                              newInitialItems[currentContext][index] = item
                              break
                            }
                          }
                          setInitialItems(newInitialItems)
                          goToNextUnfinishedItem(filteredItems, previousUnfinishedItems, fieldIndex, currentContext)
                        }}
                        size="small"
                        component="label"
                      >
                        <FastForwardRounded />
                      </IconButton>
                    </Tooltip>
                    {
                      currentRole === "Global Administrator" &&
                        <Tooltip title={(!autoTranslationSupported || filteredSources.length === 0) ? "" : "Auto-translation"}>
                          <LoadingButton
                            sx={{
                              width: "50px !important",
                              height: "50px !important",
                              color: `${mode === "dark" ? "white" : "rgba(0, 0, 0, 0.54)"}`,
                              fontSize: "1.125em",
                              borderRadius: "50%",
                              padding: "5px",
                              minWidth: "50px",
                              "&:hover": {
                                backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)"}`
                              }
                            }}
                            role="button"
                            aria-labelledby="auto-translation"
                            aria-describedby="use DeepL to translate the current sentence"
                            loading={autoTranslateFieldLoading}
                            disabled={!autoTranslationSupported || filteredSources.length === 0}
                            onClick={() => {
                              socket.emit('auto_translate', filteredSources.at(fieldIndex).innerHTML, selectedTranslationFile)
                            }}
                            size="small"
                            component="label"
                          >
                            <BsTranslate />
                          </LoadingButton>
                        </Tooltip>
                    }
                  </div>
              }
            </Box>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                width: "100%",
                marginTop: ".25em"
              }}
            >
              <Tooltip title={"Open file"}>
                <IconButton
                  sx={{
                    width: "50px",
                    height: "50px"
                  }}
                  role="button"
                  aria-labelledby="open file"
                  aria-describedby="open a new translation file"
                  onClick={() => {
                    let modifiedItems = false
                    for (const contextName of Object.keys(initialItems)) {
                      for (const item of initialItems[contextName]) {
                        if (item.newTranslation !== undefined || item.newState !== undefined || item.newTranslator !== undefined) {
                          modifiedItems = true
                          break
                        }
                      }
                      if (modifiedItems) {
                        break
                      }
                    }
                    if (modifiedItems) {
                      setCloseFileOnSelectFileDialogOpen(true)
                    } else {
                      setContextFilter("None")
                      setContexts(undefined)
                      setContextsNames([])
                      setFieldIndex(-1)
                      setSources([])
                      setTranslations([])
                      setMessages([])
                      setCurrentTranslation("")
                      setCurrentTranslations([])
                      setFileContent(undefined)
                      setSelectedFilesCategory("")
                      setSelectedTranslationFilesCategory("")
                      setSelectedTranslationFile("")
                      setFieldType("unfinished")
                      setFieldTypes([])
                      setAutoTranslationSupported(false)
                      setHistory([])
                      setInitialItems({})
                      setSelectFileDialogOpen(true)
                    }
                  }}
                  size="small"
                  component="label"
                >
                  <FileOpenRounded />
                </IconButton>
              </Tooltip>
              <Tooltip title={sources.length === 0 ? "" : "Save file"}>
                <IconButton
                  sx={{
                    width: "50px",
                    height: "50px"
                  }}
                  role="button"
                  aria-labelledby="save file"
                  aria-describedby="save the modified translation file"
                  disabled={sources.length === 0}
                  onClick={() => {
                    let modifiedItems: any = {}
                    for (const contextName of Object.keys(initialItems)) {
                      for (const item of initialItems[contextName]) {
                        if (item.newTranslation !== undefined || item.newState !== undefined || item.newTranslator !== undefined) {
                          if (!modifiedItems[contextName]) {
                            modifiedItems[contextName] = []
                          }
                          modifiedItems[contextName].push(item)
                        }
                      }
                    }
                    if (Object.keys(modifiedItems).length === 0) {
                      makeToast("error", "No changes were made, file was not saved.", mode)
                    } else {
                      let filePath: string = ""
                      if (selectedFilesCategory === "Embosser") {
                        filePath = `${selectedFirmwareVersion}/${translationFilesCategories[selectedTranslationFilesCategory]}/${selectedTranslationFile}`
                      } else {
                        filePath = `IBTG/${selectedTranslationFile}`
                      }
                      socket.emit('update_history', selectedTranslationFile, user!.displayName, user!.photoURL, new Date().getTime(), modifiedItems)
                      socket.emit('save_file_content', formatXml(new XMLSerializer().serializeToString(fileContent as Node), { collapseContent: true }), selectedTranslationFile, filePath)

                    }
                  }}
                  size="small"
                  component="label"
                >
                  <SaveRounded />
                </IconButton>
              </Tooltip>
              {
                currentRole === "Global Administrator" &&
                  <Tooltip title={(!autoTranslationSupported || sources.length === 0) ? "" : "Auto-translate file"}>
                    <LoadingButton
                      sx={{
                        width: "50px !important",
                        height: "50px !important",
                        color: `${mode === "dark" ? "white" : "rgba(0, 0, 0, 0.54)"}`,
                        fontSize: "1.125em",
                        borderRadius: "50%",
                        padding: "5px",
                        minWidth: "50px",
                        "&:hover": {
                          backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)"}`
                        }
                      }}
                      role="button"
                      aria-labelledby="auto-translate file"
                      aria-describedby="use DeepL to translate the entire file"
                      loading={autoTranslateFileLoading}
                      disabled={!autoTranslationSupported || filteredSources.length === 0}
                      onClick={() => {
                        let emptyFields: any = {}
                        for (let contextKey of Object.keys(contexts)) {
                          for (let [index, source]  of contexts[contextKey].sources.entries()) {
                            if (contexts[contextKey].translations[index].getAttribute("type") === "unfinished") {
                              if (emptyFields[contextKey] === undefined) {
                                emptyFields[contextKey] = {
                                  indexes: [],
                                  sources: []
                                }
                              }
                              emptyFields[contextKey].indexes.push(index)
                              emptyFields[contextKey].sources.push(source.innerHTML)
                            }
                          }
                        }
                        setAutoTranslateFileLoading(true)
                        socket.emit('auto_translate_file', selectedTranslationFile, emptyFields)
                      }}
                      size="small"
                      component="label"
                    >
                      <TaskRounded />
                    </LoadingButton>
                  </Tooltip>
              }
              {
                sources.length !== 0 ?
                  <Tooltip title={"Download file"}>
                    <IconButton
                      sx={{
                        width: "50px",
                        height: "50px"
                      }}
                      role="button"
                      aria-labelledby="download file"
                      aria-describedby="download the translation file"
                      onClick={() => {
                        var file = new Blob([formatXml(new XMLSerializer().serializeToString(fileContent as Node), { collapseContent: true })], {type: "text/xml"});
                        if (window.navigator.msSaveOrOpenBlob) // IE10+
                            window.navigator.msSaveOrOpenBlob(file, selectedTranslationFile);
                        else { // Others
                            var a = document.createElement("a"),
                                    url = URL.createObjectURL(file);
                            a.href = url;
                            a.download = selectedTranslationFile;
                            document.body.appendChild(a);
                            a.click();
                            setTimeout(function() {
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(url);
                            }, 0);
                        }
                        socket.emit('update_history', selectedTranslationFile, user!.displayName, user!.photoURL, new Date().getTime(), "Download")
                      }}
                      size="small"
                      component="label"
                    >
                      <FileDownloadRounded />
                    </IconButton>
                  </Tooltip>
                :
                  <>
                    <input
                      style={{ display: 'none' }}
                      id={`file-input`}
                      type="file"
                      ref={fileInput}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const fileName = event.currentTarget.files![0].name
                        if ((selectedFirmwareVersion === "FW2" && (speechTranslationFilesFW2.includes(fileName) || webInterfaceTranslationFilesFW2.includes(fileName))) || (selectedFirmwareVersion === "FW3" && (speechTranslationFilesFW3.includes(fileName) || webInterfaceTranslationFilesFW3.includes(fileName))) || (selectedFilesCategory === "Index Braille Tactile Graphics" && IBTGTranslationFiles.includes(fileName))) {
                          try {
                            let fileReader = new FileReader()
                            fileReader.onloadend = () => {
                              const text = fileReader.result || ""
                              const fileCategory = fileName.includes("libtranslation") ? "Speech" : "Web Interface"
                              let filePath: string = ""
                              if (selectedFilesCategory === "Embosser") {
                                filePath = `${selectedFirmwareVersion}/${translationFilesCategories[fileCategory]}/${fileName}`
                              } else {
                                filePath = `IBTG/${fileName}`
                              }
                              socket.emit('update_history', fileName, user!.displayName, user!.photoURL, new Date().getTime(), "Upload")
                              socket.emit('save_file_content', text, fileName, filePath)
                            }
                            fileReader.readAsText(event.currentTarget.files![0])
                          } catch (error) {
                            makeToast("error", "Could not read file, please try again", mode)
                          }
                        } else {
                          makeToast("error", "The chosen file does not exist on the server, could not complete upload request", mode)
                        }
                      }}
                    />
                    <Tooltip title={"Upload file"}>
                      <IconButton
                        component="span"
                        sx={{
                          width: "50px",
                          height: "50px"
                        }}
                        role="button"
                        aria-labelledby="upload file"
                        aria-describedby="upload the locally modified translation file"
                        size="small"
                        onClick={() => {
                          setSelectFirmwareVersionDialogOpen(true)
                        }}
                      >
                        <FileUploadRounded />
                      </IconButton>
                    </Tooltip>
                  </>
              }
              <Tooltip title={"Close file"}>
                <IconButton
                  component="span"
                  sx={{
                    width: "50px",
                    height: "50px"
                  }}
                  role="button"
                  aria-labelledby="close file"
                  aria-describedby="close the current translation file"
                  disabled={sources.length === 0}
                  size="small"
                  onClick={() => {
                    let modifiedItems = false
                    for (const contextName of Object.keys(initialItems)) {
                      for (const item of initialItems[contextName]) {
                        if (item.newTranslation !== undefined || item.newState !== undefined || item.newTranslator !== undefined) {
                          modifiedItems = true
                          break
                        }
                      }
                      if (modifiedItems) {
                        break
                      }
                    }
                    if (modifiedItems) {
                      setCloseFileDialogOpen(true)
                    } else {
                      setContextFilter("None")
                      setContexts(undefined)
                      setContextsNames([])
                      setFieldIndex(-1)
                      setSources([])
                      setTranslations([])
                      setMessages([])
                      setCurrentTranslation("")
                      setCurrentTranslations([])
                      setFileContent(undefined)
                      setSelectedFilesCategory("")
                      setSelectedTranslationFilesCategory("")
                      setSelectedTranslationFile("")
                      setFieldType("unfinished")
                      setFieldTypes([])
                      setAutoTranslationSupported(false)
                      setHistory([])
                      setInitialItems({})
                    }
                  }}
                >
                  <CancelRounded />
                </IconButton>
              </Tooltip>
            </div>
          </Box>
          <Box
            className={classes.historyCard}
            sx={{
              width: "100% !important",
              height: "fit-content !important"
            }}
          >
            <MultiplePropertiesArea
              key={`history_panel`}
              property={"History"}
              classes={classes}
              children={
                history.map((historyEntry, index) => (
                  <PropertyArea
                    key={`${historyEntry}${index}`}
                    property={`User & Date - ${historyEntry.changes[0].Action === "Upload" ? "Uploaded" : historyEntry.changes[0].Action === "Download" ? "Downloaded" : "Changed"}`}
                    image={historyEntry.userPhotoURL ? historyEntry.userPhotoURL : "https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/media%2Fno-profile-picture.webp?alt=media&token=6abea430-fe92-4cb6-a959-229afc327022"}
                    content={`${historyEntry.userName} - ${new Date(historyEntry.date).toLocaleString('en-GB')}`}
                    classes={{
                      container: `${classes['propertyArea']} ${index > 0 && classes['propertyAreaTopMargin']}`,
                      property: classes['propertyAreaProperty'],
                      content: classes['propertyAreaContent']
                    }}
                    actionButton={historyEntry.changes[0].Action ? false : true}
                    actionButtonsList={[
                      {
                        tooltip: "Show details",
                        disabled: false,
                        onClick: () => {
                          let newHistoryEntryChanges: any = {}
                          for (const change of historyEntry.changes) {
                            if (!newHistoryEntryChanges[change.Context]) {
                              newHistoryEntryChanges[change.Context] = []
                            }
                            newHistoryEntryChanges[change.Context].push({
                              source: change.Source,
                              initialTranslation: change.InitialTranslation,
                              initialState: change.InitialState,
                              initialTranslator: change.InitialTranslator,
                              newTranslation: change.NewTranslation,
                              newState: change.NewState,
                              newTranslator: change.NewTranslator
                            })
                          }
                          setHistoryEntryChanges(newHistoryEntryChanges)
                          setHistoryModalOpen(true)
                        },
                        icon: <OpenInNewRounded />
                      }
                    ]}
                  />
                ))
              }
              actionButton={true}
              actionButtonsFocusDisabled={true}
              actionButtonsList={currentRole === "Global Administrator" ? [
                {
                  tooltip: "Clear History",
                  disabled: history.length === 0,
                  onClick: () => {
                    socket.emit('clear_history', selectedTranslationFile)
                  },
                  icon: <RefreshRounded />,
                  loading: clearHistoryLoading
                }
              ] : []}
            />
          </Box>
        </Box>
        <Dialog
          open={dialogOpen}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={() => setDialogOpen(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="file modified"
          aria-describedby="dialog that notifies a user that the file was modified by another user and asks him to keep the current changes, or overwrite them with the new changes."
        >
          <DialogTitle id="file-modified-dialog-title">
            File Modified
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="file-modified-dialog-description">
              {`File ${selectedTranslationFile} was modified by another user. Do you want to overwrite the items or keep the current changes? Overwriting will discard your changes.`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDialogOpen(false)}
              color="error"
            >
              Discard
            </Button>
            <Button
              onClick={() => {
                let filePath: string = ""
                if (selectedFilesCategory === "Embosser") {
                  filePath = `${selectedFirmwareVersion}/${translationFilesCategories[selectedTranslationFilesCategory]}/${selectedTranslationFile}`
                } else {
                  filePath = `IBTG/${selectedTranslationFile}`
                }
                socket.emit("get_file_content", selectedTranslationFile, filePath)
                setDialogOpen(false)
              }}
              autoFocus
              color="secondary"
            >
              Overwrite
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={selectFirmwareVersionDialogOpen}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={() => setSelectFirmwareVersionDialogOpen(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="firmware version"
          aria-describedby="dialog that asks a user to input the desire firmware version for the translation file"
        >
          <DialogTitle id="firmware-version-dialog-title">
            Firmware Version
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="firmware-version-dialog-description">
              {`Select the desired options for the translation file.`}
            </DialogContentText>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                marginTop: "1em",
                gap: ".25em"
              }}
            >
              <p>
                File Category
              </p>
              <Select
                value={selectedFilesCategory}
                displayEmpty
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <>None</>;
                  }
                  return selected;
                }}
                onChange={(event) => {
                  const { target: { value } } = event
                  setSelectedFilesCategory(value)
                }}
                sx={{
                  borderRadius: "10px",
                  marginBottom: "1em"
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      backgroundColor: mode === 'light' ? "#fff" : "#151515",
                      borderRadius: '10px',
                      '&::-webkit-scrollbar': {
                        width: ".3em",
                      },
                      '&::-webkit-scrollbar-track': {
                        background: "transparent",
                        boxShadow: "inset 0 0 10px #1c1c1c",
                        borderRadius: "5px",
                        borderLeft: "1px solid transparent",
                        borderRight: "1px solid transparent",
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#444',
                        outline: '1px solid #444',
                        borderRadius: ".15em"
                      }
                    }
                  }
                }}
                input={<OutlinedInput />}
              >
              {
                filesCategories.map((item: string) => (
                  <MenuItem
                    key={item}
                    value={item}
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: "rgba(133, 210, 1, 0.3)",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "rgba(133, 210, 1, 0.3)",
                      },
                      "&:hover": {
                        backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                      }
                    }}
                  >
                    {item}
                  </MenuItem>
                ))
              }
              </Select>
              {
                selectedFilesCategory === "Embosser" &&
                  <>
                    <p>
                      Firmware Version
                    </p>
                    <Select
                      value={selectedFirmwareVersion}
                      onChange={(event) => {
                        const { target: { value } } = event
                        setSelectedFirmwareVersion(value)

                        let newTranslationFilesCategories = []
                        if (value === "FW2") {
                          let speechFilesAvailable = false
                          let webInterfaceFilesAvailable = false
                          if (user!.availableSpeechTranslationFiles !== "") {
                            for (let file of user!.availableSpeechTranslationFiles.split(';')) {
                              if (!file.includes("fw3")) {
                                speechFilesAvailable = true
                                break
                              }
                            }
                          }
                          if (user!.availableWebInterfaceTranslationFiles !== "") {
                            for (let file of user!.availableWebInterfaceTranslationFiles.split(';')) {
                              if (!file.includes("fw3")) {
                                webInterfaceFilesAvailable = true
                                break
                              }
                            }
                          }
                          if (speechFilesAvailable || currentRole === "Global Administrator") {
                            newTranslationFilesCategories.push("Speech")
                          }
                          if (webInterfaceFilesAvailable || currentRole === "Global Administrator") {
                            newTranslationFilesCategories.push("Web Interface")
                          }
                        }
                        if (value === "FW3") {
                          let speechFilesAvailable = false
                          let webInterfaceFilesAvailable = false
                          if (user!.availableSpeechTranslationFiles !== "") {
                            for (let file of user!.availableSpeechTranslationFiles.split(';')) {
                              if (file.includes("fw3")) {
                                speechFilesAvailable = true
                                break
                              }
                            }
                          }
                          if (user!.availableWebInterfaceTranslationFiles !== "") {
                            for (let file of user!.availableWebInterfaceTranslationFiles.split(';')) {
                              if (file.includes("fw3")) {
                                webInterfaceFilesAvailable = true
                                break
                              }
                            }
                          }
                          if (speechFilesAvailable || currentRole === "Global Administrator") {
                            newTranslationFilesCategories.push("Speech")
                          }
                          if (webInterfaceFilesAvailable || currentRole === "Global Administrator") {
                            newTranslationFilesCategories.push("Web Interface")
                          }
                        }
                        setAvailableTranslationFilesCategories(newTranslationFilesCategories)
                        if (!newTranslationFilesCategories.includes(selectedTranslationFilesCategory)) {
                          setSelectedTranslationFilesCategory("")
                        }
                      }}
                      sx={{
                        borderRadius: "10px",
                        marginBottom: "1em"
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: mode === 'light' ? "#fff" : "#151515",
                            borderRadius: '10px',
                            '&::-webkit-scrollbar': {
                              width: ".3em",
                            },
                            '&::-webkit-scrollbar-track': {
                              background: "transparent",
                              boxShadow: "inset 0 0 10px #1c1c1c",
                              borderRadius: "5px",
                              borderLeft: "1px solid transparent",
                              borderRight: "1px solid transparent",
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#444',
                              outline: '1px solid #444',
                              borderRadius: ".15em"
                            }
                          }
                        }
                      }}
                      input={<OutlinedInput />}
                    >
                    {
                      availableFirmwareVersions.map((item: string) => (
                        <MenuItem
                          key={item}
                          value={item}
                          sx={{
                            "&.Mui-selected": {
                              backgroundColor: "rgba(133, 210, 1, 0.3)",
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: "rgba(133, 210, 1, 0.3)",
                            },
                            "&:hover": {
                              backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                            }
                          }}
                        >
                          {item}
                        </MenuItem>
                      ))
                    }
                    </Select>
                  </>
              }
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setSelectFirmwareVersionDialogOpen(false)}
              color="error"
            >
              Cancel
            </Button>
            <Button
              disabled={selectedFilesCategory === "" || (selectedFilesCategory === "Embosser" && selectedFirmwareVersion === "")}
              onClick={() => {
                fileInput.current?.click()
                setSelectFirmwareVersionDialogOpen(false)
              }}
              autoFocus
              color="secondary"
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={selectFileDialogOpen}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={() => setSelectFileDialogOpen(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="select file"
          aria-describedby="dialog that lets the user select the file he wants to translate"
        >
          <DialogTitle id="select-file-dialog-title">
            Select File
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="select-file-dialog-description">
              {`Select the file that you want to translate.`}
            </DialogContentText>
            {
              currentRole === "Global Administrator" ?
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "1em",
                    gap: ".25em"
                  }}
                >
                  <p>
                    Files Category
                  </p>
                  <Select
                    value={selectedFilesCategory}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <>None</>;
                      }
                      return selected;
                    }}
                    onChange={(event) => {
                      const { target: { value } } = event
                      setSelectedFilesCategory(value)
                      setSelectedTranslationFile("")
                    }}
                    sx={{
                      borderRadius: "10px",
                      marginBottom: "1em"
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: mode === 'light' ? "#fff" : "#151515",
                          borderRadius: '10px',
                          '&::-webkit-scrollbar': {
                            width: ".3em",
                          },
                          '&::-webkit-scrollbar-track': {
                            background: "transparent",
                            boxShadow: "inset 0 0 10px #1c1c1c",
                            borderRadius: "5px",
                            borderLeft: "1px solid transparent",
                            borderRight: "1px solid transparent",
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#444',
                            outline: '1px solid #444',
                            borderRadius: ".15em"
                          }
                        }
                      }
                    }}
                    input={<OutlinedInput />}
                  >
                  {
                    filesCategories.map((item: string) => (
                      <MenuItem
                        key={item}
                        value={item}
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: "rgba(133, 210, 1, 0.3)",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "rgba(133, 210, 1, 0.3)",
                          },
                          "&:hover": {
                            backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                          }
                        }}
                      >
                        {item}
                      </MenuItem>
                    ))
                  }
                  </Select>
                  {
                    selectedFilesCategory === "Embosser" &&
                      <>
                        <p>
                          Firmware Version
                        </p>
                        <Select
                          value={selectedFirmwareVersion}
                          onChange={(event) => {
                            const { target: { value } } = event
                            setSelectedFirmwareVersion(value)

                            let newTranslationFilesCategories = []
                            if (value === "FW2") {
                              let speechFilesAvailable = false
                              let webInterfaceFilesAvailable = false
                              if (user!.availableSpeechTranslationFiles !== "") {
                                for (let file of user!.availableSpeechTranslationFiles.split(';')) {
                                  if (!file.includes("fw3")) {
                                    speechFilesAvailable = true
                                    break
                                  }
                                }
                              }
                              if (user!.availableWebInterfaceTranslationFiles !== "") {
                                for (let file of user!.availableWebInterfaceTranslationFiles.split(';')) {
                                  if (!file.includes("fw3")) {
                                    webInterfaceFilesAvailable = true
                                    break
                                  }
                                }
                              }
                              if (speechFilesAvailable || currentRole === "Global Administrator") {
                                newTranslationFilesCategories.push("Speech")
                              }
                              if (webInterfaceFilesAvailable || currentRole === "Global Administrator") {
                                newTranslationFilesCategories.push("Web Interface")
                              }
                            }
                            if (value === "FW3") {
                              let speechFilesAvailable = false
                              let webInterfaceFilesAvailable = false
                              if (user!.availableSpeechTranslationFiles !== "") {
                                for (let file of user!.availableSpeechTranslationFiles.split(';')) {
                                  if (file.includes("fw3")) {
                                    speechFilesAvailable = true
                                    break
                                  }
                                }
                              }
                              if (user!.availableWebInterfaceTranslationFiles !== "") {
                                for (let file of user!.availableWebInterfaceTranslationFiles.split(';')) {
                                  if (file.includes("fw3")) {
                                    webInterfaceFilesAvailable = true
                                    break
                                  }
                                }
                              }
                              if (speechFilesAvailable || currentRole === "Global Administrator") {
                                newTranslationFilesCategories.push("Speech")
                              }
                              if (webInterfaceFilesAvailable || currentRole === "Global Administrator") {
                                newTranslationFilesCategories.push("Web Interface")
                              }
                            }
                            setAvailableTranslationFilesCategories(newTranslationFilesCategories)
                            if (!newTranslationFilesCategories.includes(selectedTranslationFilesCategory)) {
                              setSelectedTranslationFilesCategory("")
                            }
                          }}
                          sx={{
                            borderRadius: "10px",
                            marginBottom: "1em"
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                backgroundColor: mode === 'light' ? "#fff" : "#151515",
                                borderRadius: '10px',
                                '&::-webkit-scrollbar': {
                                  width: ".3em",
                                },
                                '&::-webkit-scrollbar-track': {
                                  background: "transparent",
                                  boxShadow: "inset 0 0 10px #1c1c1c",
                                  borderRadius: "5px",
                                  borderLeft: "1px solid transparent",
                                  borderRight: "1px solid transparent",
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#444',
                                  outline: '1px solid #444',
                                  borderRadius: ".15em"
                                }
                              }
                            }
                          }}
                          input={<OutlinedInput />}
                        >
                        {
                          availableFirmwareVersions.map((item: string) => (
                            <MenuItem
                              key={item}
                              value={item}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "rgba(133, 210, 1, 0.3)",
                                },
                                "&.Mui-selected:hover": {
                                  backgroundColor: "rgba(133, 210, 1, 0.3)",
                                },
                                "&:hover": {
                                  backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                                }
                              }}
                            >
                              {item}
                            </MenuItem>
                          ))
                        }
                        </Select>
                        <p>
                          Category
                        </p>
                        <Select
                          value={selectedTranslationFilesCategory}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return <>None</>;
                            }
                            return selected;
                          }}
                          onChange={(event) => {
                            const { target: { value } } = event
                            setSelectedTranslationFilesCategory(value)
                            setSelectedTranslationFile("")
                          }}
                          sx={{
                            borderRadius: "10px",
                            marginBottom: "1em"
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                backgroundColor: mode === 'light' ? "#fff" : "#151515",
                                borderRadius: '10px',
                                '&::-webkit-scrollbar': {
                                  width: ".3em",
                                },
                                '&::-webkit-scrollbar-track': {
                                  background: "transparent",
                                  boxShadow: "inset 0 0 10px #1c1c1c",
                                  borderRadius: "5px",
                                  borderLeft: "1px solid transparent",
                                  borderRight: "1px solid transparent",
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#444',
                                  outline: '1px solid #444',
                                  borderRadius: ".15em"
                                }
                              }
                            }
                          }}
                          input={<OutlinedInput />}
                        >
                        {
                          availableTranslationFilesCategories.length !== 0 ?
                            availableTranslationFilesCategories.map((item: string) => (
                              <MenuItem
                                key={item}
                                value={item}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "rgba(133, 210, 1, 0.3)",
                                  },
                                  "&.Mui-selected:hover": {
                                    backgroundColor: "rgba(133, 210, 1, 0.3)",
                                  },
                                  "&:hover": {
                                    backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                                  }
                                }}
                              >
                                {item}
                              </MenuItem>
                            ))
                          :
                            <MenuItem disabled value="">
                              <>None</>
                            </MenuItem>
                        }
                        </Select>
                      </>
                  }
                  {
                    selectedFilesCategory !== "" &&
                      <>
                        <p>
                          File
                        </p>
                        <Select
                          value={selectedTranslationFile}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return <>None</>;
                            }
                            return selected;
                          }}
                          disabled={selectedTranslationFilesCategory === "" && selectedFilesCategory !== "Index Braille Tactile Graphics"}
                          onChange={(event) => {
                            const { target: { value } } = event
                            setSelectedTranslationFile(value)
                          }}
                          sx={{
                            borderRadius: "10px"
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                backgroundColor: mode === 'light' ? "#fff" : "#151515",
                                borderRadius: '10px',
                                '&::-webkit-scrollbar': {
                                  width: ".3em",
                                },
                                '&::-webkit-scrollbar-track': {
                                  background: "transparent",
                                  boxShadow: "inset 0 0 10px #1c1c1c",
                                  borderRadius: "5px",
                                  borderLeft: "1px solid transparent",
                                  borderRight: "1px solid transparent",
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#444',
                                  outline: '1px solid #444',
                                  borderRadius: ".15em"
                                }
                              }
                            }
                          }}
                          input={<OutlinedInput />}
                        >
                        {
                          selectedFilesCategory === "Index Braille Tactile Graphics" ?
                            IBTGTranslationFiles.sort().map((item: string) => (
                              <MenuItem
                                key={item}
                                value={item}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "rgba(133, 210, 1, 0.3)",
                                  },
                                  "&.Mui-selected:hover": {
                                    backgroundColor: "rgba(133, 210, 1, 0.3)",
                                  },
                                  "&:hover": {
                                    backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                                  }
                                }}
                              >
                                {item}
                              </MenuItem>
                            ))
                          :
                          selectedFirmwareVersion === "FW3" ?
                            selectedTranslationFilesCategory === "Speech" ?
                              speechTranslationFilesFW3.sort().map((item: string) => (
                                <MenuItem
                                  key={item}
                                  value={item}
                                  sx={{
                                    "&.Mui-selected": {
                                      backgroundColor: "rgba(133, 210, 1, 0.3)",
                                    },
                                    "&.Mui-selected:hover": {
                                      backgroundColor: "rgba(133, 210, 1, 0.3)",
                                    },
                                    "&:hover": {
                                      backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                                    }
                                  }}
                                >
                                  {item}
                                </MenuItem>
                              ))
                            :
                              selectedTranslationFilesCategory === "Web Interface" ?
                                webInterfaceTranslationFilesFW3.sort().map((item: string) => (
                                  <MenuItem
                                    key={item}
                                    value={item}
                                    sx={{
                                      "&.Mui-selected": {
                                        backgroundColor: "rgba(133, 210, 1, 0.3)",
                                      },
                                      "&.Mui-selected:hover": {
                                        backgroundColor: "rgba(133, 210, 1, 0.3)",
                                      },
                                      "&:hover": {
                                        backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                                      }
                                    }}
                                  >
                                    {item}
                                  </MenuItem>
                                ))
                              :
                                <MenuItem disabled value="">
                                  <>None</>
                                </MenuItem>
                          :
                          selectedTranslationFilesCategory === "Speech" ?
                            speechTranslationFilesFW2.sort().map((item: string) => (
                              <MenuItem
                                key={item}
                                value={item}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "rgba(133, 210, 1, 0.3)",
                                  },
                                  "&.Mui-selected:hover": {
                                    backgroundColor: "rgba(133, 210, 1, 0.3)",
                                  },
                                  "&:hover": {
                                    backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                                  }
                                }}
                              >
                                {item}
                              </MenuItem>
                            ))
                          :
                            selectedTranslationFilesCategory === "Web Interface" ?
                              webInterfaceTranslationFilesFW2.sort().map((item: string) => (
                                <MenuItem
                                  key={item}
                                  value={item}
                                  sx={{
                                    "&.Mui-selected": {
                                      backgroundColor: "rgba(133, 210, 1, 0.3)",
                                    },
                                    "&.Mui-selected:hover": {
                                      backgroundColor: "rgba(133, 210, 1, 0.3)",
                                    },
                                    "&:hover": {
                                      backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                                    }
                                  }}
                                >
                                  {item}
                                </MenuItem>
                              ))
                            :
                              <MenuItem disabled value="">
                                <>None</>
                              </MenuItem>
                        }
                        </Select>
                      </>
                  }
                </Box>
              :
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "1em",
                    gap: ".25em"
                  }}
                >
                  <p>
                    File
                  </p>
                  <Select
                    value={selectedTranslationFile}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return "None"
                      }
                      return selected;
                    }}
                    disabled={user!.availableSpeechTranslationFiles === "" && user!.availableWebInterfaceTranslationFiles === ""}
                    onChange={(event) => {
                      const { target: { value } } = event

                      // [S.S.] Since we no longer have select fields for the other components required to find a file's path
                      // on the backend side, we have to deduce them.
                      if (value.includes("ibtg")) {
                        // [S.S.] If the selected file's name starts with "ibtg", we know the file is an IBTG translation file,
                        // otherwise it is an Embosser file.
                        setSelectedFilesCategory("IBTG")
                      } else {
                        setSelectedFilesCategory("Embosser")
                      }

                      if (value.includes("fw3")) {
                        // [S.S.] If the selected file's name starts with "fw3", we know the file is a FW3 translation file,
                        // otherwise it is a FW2 file.
                        setSelectedFirmwareVersion("FW3")
                      } else {
                        setSelectedFirmwareVersion("FW2")
                      }

                      if (value.includes("i18n")) {
                        // [S.S.] If the selected file's name starts with "i18n", we know the file is a Web Interface translation file,
                        // otherwise it is a Speech translation file.
                        setSelectedTranslationFilesCategory("Web Interface")
                      } else {
                        setSelectedTranslationFilesCategory("Speech")
                      }

                      setSelectedTranslationFile(value)
                    }}
                    sx={{
                      borderRadius: "10px"
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: mode === 'light' ? "#fff" : "#151515",
                          borderRadius: '10px',
                          '&::-webkit-scrollbar': {
                            width: ".3em",
                          },
                          '&::-webkit-scrollbar-track': {
                            background: "transparent",
                            boxShadow: "inset 0 0 10px #1c1c1c",
                            borderRadius: "5px",
                            borderLeft: "1px solid transparent",
                            borderRight: "1px solid transparent",
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#444',
                            outline: '1px solid #444',
                            borderRadius: ".15em"
                          }
                        }
                      }
                    }}
                    input={<OutlinedInput />}
                  >
                  {
                    user!.availableSpeechTranslationFiles !== "" || user!.availableWebInterfaceTranslationFiles !== "" || user!.availableIBTGTranslationFiles !== "" ?
                      [...user!.availableSpeechTranslationFiles.split(';'), ...user!.availableWebInterfaceTranslationFiles.split(';'), ...user!.availableIBTGTranslationFiles.split(';')].filter(fileName => fileName !== "").sort().map((item: string) => (
                        <MenuItem
                          key={item}
                          value={item}
                          sx={{
                            "&.Mui-selected": {
                              backgroundColor: "rgba(133, 210, 1, 0.3)",
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: "rgba(133, 210, 1, 0.3)",
                            },
                            "&:hover": {
                              backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                            }
                          }}
                        >
                          {item}
                        </MenuItem>
                      ))
                    :
                      <MenuItem disabled value="">
                        <>None</>
                      </MenuItem>
                  }
                  </Select>
                </Box>
            }
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setSelectFileDialogOpen(false)}
              color="error"
            >
              Cancel
            </Button>
            <Button
              disabled={selectedTranslationFile === ""}
              onClick={() => {
                let filePath: string = ""
                if (selectedFilesCategory === "Embosser") {
                  filePath = `${selectedFirmwareVersion}/${translationFilesCategories[selectedTranslationFilesCategory]}/${selectedTranslationFile}`
                } else {
                  filePath = `IBTG/${selectedTranslationFile}`
                }
                socket.emit("get_file_content", selectedTranslationFile, filePath)
                setSelectFileDialogOpen(false)
              }}
              autoFocus
              color="secondary"
            >
              Open
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={closeFileDialogOpen}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={() => setCloseFileDialogOpen(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="unsaved changes"
          aria-describedby="dialog that notifies a user there are unsaved changes when the translation file is being closed"
        >
          <DialogTitle id="unsaved-changes-dialog-title">
            Unsaved Changes
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="unsaved-changes-dialog-description">
              {`There are unsaved changes. Do you want to save or discard them?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setCloseFileDialogOpen(false)}
              color="error"
            >
              Cancel
            </Button>
            <div style={{ flexGrow: "1" }} />
            <Button
              onClick={() => {
                setContextFilter("None")
                setContexts(undefined)
                setContextsNames([])
                setFieldIndex(-1)
                setSources([])
                setTranslations([])
                setMessages([])
                setCurrentTranslation("")
                setCurrentTranslations([])
                setFileContent(undefined)
                setSelectedFilesCategory("")
                setSelectedTranslationFilesCategory("")
                setSelectedTranslationFile("")
                setFieldType("unfinished")
                setFieldTypes([])
                setAutoTranslationSupported(false)
                setHistory([])
                setInitialItems({})
                setCloseFileDialogOpen(false)
              }}
              color="error"
            >
              Discard
            </Button>
            <Button
              onClick={() => {
                // [S.S.] Saving the current changes
                let modifiedItems: any = {}
                for (const contextName of Object.keys(initialItems)) {
                  for (const item of initialItems[contextName]) {
                    if (item.newTranslation !== undefined || item.newState !== undefined || item.newTranslator !== undefined) {
                      if (!modifiedItems[contextName]) {
                        modifiedItems[contextName] = []
                      }
                      modifiedItems[contextName].push(item)
                    }
                  }
                }
                if (Object.keys(modifiedItems).length === 0) {
                  makeToast("error", "No changes were made, file was not saved.", mode)
                } else {
                  let filePath: string = ""
                  if (selectedFilesCategory === "Embosser") {
                    filePath = `${selectedFirmwareVersion}/${translationFilesCategories[selectedTranslationFilesCategory]}/${selectedTranslationFile}`
                  } else {
                    filePath = `IBTG/${selectedTranslationFile}`
                  }
                  socket.emit('update_history', selectedTranslationFile, user!.displayName, user!.photoURL, new Date().getTime(), modifiedItems)
                  socket.emit('save_file_content', formatXml(new XMLSerializer().serializeToString(fileContent as Node), { collapseContent: true }), selectedTranslationFile, filePath)
                  setFileClosed(true)
                }
                setCloseFileDialogOpen(false)
              }}
              autoFocus
              color="secondary"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openItemNotOnListDialog}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.1)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={ () => setOpenItemNotOnListDialog(false) }
          fullWidth
          disableRestoreFocus
          maxWidth="xs"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              color: mode === 'light' ? "#252525" : "#f6f6f6"
            }}
          >
            Translation item state is not filtered
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                color: mode === 'light' ? "#252525" : "#f6f6f6"
              }}
            >
              {"Item cannot be viewed because it is no longer on the filtered list."}
              <br />
              {"Press the refresh button to update the list."}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={ () => setOpenItemNotOnListDialog(false) }
              size="large"
              sx={{
                fontWeight: "bold",
                color: "#85d201"
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={closeFileOnSelectFileDialogOpen}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={() => setCloseFileOnSelectFileDialogOpen(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="unsaved changes"
          aria-describedby="dialog that notifies the user there are unsaved changes when opening a new translation file while editing another one"
        >
          <DialogTitle id="unsaved-changes-open-file-dialog-title">
            Unsaved Changes
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="unsaved-changes-open-file-dialog-description">
              {`There are unsaved changes. Do you want to save or discard them before selecting a new file?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setCloseFileOnSelectFileDialogOpen(false)}
              color="error"
            >
              Cancel
            </Button>
            <div style={{ flexGrow: "1" }} />
            <Button
              onClick={() => {
                setContextFilter("None")
                setContexts(undefined)
                setContextsNames([])
                setFieldIndex(-1)
                setSources([])
                setTranslations([])
                setMessages([])
                setCurrentTranslation("")
                setCurrentTranslations([])
                setFileContent(undefined)
                setSelectedFilesCategory("")
                setSelectedTranslationFilesCategory("")
                setSelectedTranslationFile("")
                setFieldType("unfinished")
                setFieldTypes([])
                setAutoTranslationSupported(false)
                setHistory([])
                setInitialItems({})
                setCloseFileOnSelectFileDialogOpen(false)
                setSelectFileDialogOpen(true)
              }}
              color="error"
            >
              Discard
            </Button>
            <Button
              onClick={() => {
                // [S.S.] Saving the current changes
                let modifiedItems: any = {}
                for (const contextName of Object.keys(initialItems)) {
                  for (const item of initialItems[contextName]) {
                    if (item.newTranslation !== undefined || item.newState !== undefined || item.newTranslator !== undefined) {
                      if (!modifiedItems[contextName]) {
                        modifiedItems[contextName] = []
                      }
                      modifiedItems[contextName].push(item)
                    }
                  }
                }
                if (Object.keys(modifiedItems).length === 0) {
                  makeToast("error", "No changes were made, file was not saved.", mode)
                } else {
                  let filePath: string = ""
                  if (selectedFilesCategory === "Embosser") {
                    filePath = `${selectedFirmwareVersion}/${translationFilesCategories[selectedTranslationFilesCategory]}/${selectedTranslationFile}`
                  } else {
                    filePath = `IBTG/${selectedTranslationFile}`
                  }
                  socket.emit('update_history', selectedTranslationFile, user!.displayName, user!.photoURL, new Date().getTime(), modifiedItems)
                  socket.emit('save_file_content', formatXml(new XMLSerializer().serializeToString(fileContent as Node), { collapseContent: true }), selectedTranslationFile, filePath)
                  setFileClosed(true)
                }
                setCloseFileOnSelectFileDialogOpen(false)
                setSelectFileDialogOpen(true)
              }}
              autoFocus
              color="secondary"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        {
          modalOpen &&
            <Modal
              open={modalOpen}
              onClose={() => {
                setModalOpen(false)
              }}
            >
              <Box
                className={classes.modalContainer}
                sx={{
                  width: "50%",
                  minWidth: "300px",
                  maxWidth: "700px",
                  paddingTop: "1.5em !important",
                  paddingBottom: "1em",
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                <Box
                  sx={{
                    width: "98%",
                    height: "calc(100% - 1em)",
                    overflowY: "auto",
                    marginTop: "1em",
                    borderRadius: "10px",
                    marginRight: "1.5em",
                    padding: "1em"
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column"
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: mode === 'light' ? "#F6F6F6" : "#252525",
                        borderRadius: "10px",
                        boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)",
                        padding: "1em"
                      }}
                    >
                      <Typography
                        variant="h5"
                        component="h2"
                        ml={2}
                      >
                        Filter By
                      </Typography>
                      <MultiplePropertiesArea
                        topMargin={true}
                        property={"Sentence State"}
                        classes={classes}
                        children={
                          <CustomSelect
                            multiple={true}
                            nonEmpty={true}
                            items={[
                              {
                                value: "All",
                                selected: sentenceStateFilter.toLowerCase().split(';').includes("translated") && sentenceStateFilter.toLowerCase().split(';').includes("unfinished") && sentenceStateFilter.toLowerCase().split(';').includes("translated by deepl")
                              },
                              {
                                value: "Translated",
                                selected: sentenceStateFilter.toLowerCase().split(';').includes("translated")
                              },
                              {
                                value: "Unfinished",
                                selected: sentenceStateFilter.toLowerCase().split(';').includes("unfinished")
                              },
                              {
                                value: "Translated by DeepL",
                                selected: sentenceStateFilter.toLowerCase().split(';').includes("translated by deepl")
                              }
                            ]}
                            setFunction={setSentenceStateFilter as Dispatch<SetStateAction<string>>}
                          />
                        }
                      />
                      {
                        contextsNames.length > 0 &&
                          <MultiplePropertiesArea
                            topMargin={true}
                            property={"Context"}
                            classes={classes}
                            children={
                              <CustomSelect
                                multiple={true}
                                nonEmpty={true}
                                items={
                                  ["All", ...contextsNames].map((item: string) => (
                                    {
                                      value: item,
                                      selected: item === "All" ? contextFilter === contextsNames.join(";") : contextFilter.toLowerCase().includes(item.toLowerCase())
                                    }
                                  ))
                                }
                                setFunction={setContextFilter as Dispatch<SetStateAction<string>>}
                              />
                            }
                          />
                      }
                    </Box>
                  </Box>
                </Box>
                <IconButton
                  className={classes.modalButtonClose}
                  onClick={() => {
                    setModalOpen(false)
                  }}
                >
                  <CloseRounded />
                </IconButton>
                <Button
                  sx={{
                    width: "fit-content",
                    alignSelf: "flex-end",
                    marginInlineEnd: ".5em",
                    transform: "translateY(1em)",
                    color: `${mode === "dark" ? "white" : "rgba(0, 0, 0, 0.54)"}`,
                    "&:hover": {
                      backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)"}`
                    }
                  }}
                  onClick={() => setModalOpen(false)}
                >
                  Done
                </Button>
              </Box>
            </Modal>
        }
        {
          historyModalOpen &&
            <Modal
              open={historyModalOpen}
              onClose={() => {
                setHistoryEntryChanges({})
                setHistoryModalOpen(false)
              }}
            >
              <Box
                className={classes.modalContainer}
                sx={{
                  width: "70%",
                  minWidth: "300px",
                  maxWidth: "1000px",
                  paddingTop: "1.5em !important",
                  paddingBottom: "1em"
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "calc(100% - 1em)",
                    overflowY: "auto",
                    marginTop: "1em",
                    borderRadius: "10px",
                    marginRight: "1.5em"
                  }}
                >
                  <Typography
                    variant="h5"
                    component="h2"
                    ml={2}
                  >
                    History Entry Details
                  </Typography>
                  <Box
                    sx={{
                      width: "calc(100% - 1em)",
                      height: "calc(100% - 3em)",
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      padding: ".5em",
                      margin: ".5em"
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: mode === 'light' ? "#F6F6F6" : "#252525",
                        borderRadius: "10px",
                        height: "auto",
                        boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)",
                        padding: ".5em .5em .5em .5em",
                      }}
                    >
                      {
                        Object.keys(historyEntryChanges).map((contextName, index) => (
                          <MultiplePropertiesArea
                            key={contextName}
                            topMargin={index > 0}
                            paddingInline={true}
                            paddingBottom={true}
                            property={contextName}
                            classes={classes}
                            children={
                              historyEntryChanges[contextName].map((change: any, index: number) => (
                                <MultiplePropertiesArea
                                  key={`${contextName}_${change.source}`}
                                  topMargin={index > 0}
                                  property={change.source}
                                  classes={classes}
                                  children={
                                    <>
                                      {
                                        change.newTranslation !== undefined &&
                                          <div
                                            style={{
                                              width: "100%",
                                              paddingInline: ".5em",
                                              display: "flex",
                                              gap: ".5em",
                                              marginBlock: ".25em",
                                              marginBottom: `${(change.newState === undefined && change.newTranslator === undefined) ? ".5em" : ".25em"}`,
                                              alignItems: "center"
                                            }}
                                          >
                                            <PropertyArea
                                              key={`${contextName}_${change.source}_0`}
                                              property={"Previous Translation"}
                                              content={`${change.initialTranslation || "\n"}`}
                                              classes={{
                                                container: `${classes['propertyArea']} ${classes['propertyAreaMarginHorizontal']} ${classes['propertyAreaFlexGrow']}`,
                                                property: classes['propertyAreaProperty'],
                                                content: classes['propertyAreaContent']
                                              }}
                                            />
                                            <DoubleArrowRounded />
                                            <PropertyArea
                                              key={`${contextName}_${change.source}_1`}
                                              property={"New Translation"}
                                              content={`${change.newTranslation || "\n"}`}
                                              classes={{
                                                container: `${classes['propertyArea']} ${classes['propertyAreaMarginHorizontal']} ${classes['propertyAreaFlexGrow']}`,
                                                property: classes['propertyAreaProperty'],
                                                content: classes['propertyAreaContent']
                                              }}
                                            />
                                          </div>
                                      }
                                      {
                                        change.newState !== undefined &&
                                          <div
                                            style={{
                                              width: "100%",
                                              paddingInline: ".5em",
                                              display: "flex",
                                              gap: ".5em",
                                              marginBlock: ".25em",
                                              marginBottom: `${change.newTranslator === undefined ? ".5em" : ".25em"}`,
                                              alignItems: "center"
                                            }}
                                          >
                                            <PropertyArea
                                              key={`${contextName}_${change.source}_2`}
                                              property={"Previous State"}
                                              content={`${change.initialState || "\n"}`}
                                              classes={{
                                                container: `${classes['propertyArea']} ${classes['propertyAreaMarginHorizontal']} ${classes['propertyAreaFlexGrow']}`,
                                                property: classes['propertyAreaProperty'],
                                                content: classes['propertyAreaContent']
                                              }}
                                            />
                                            <DoubleArrowRounded />
                                            <PropertyArea
                                              key={`${contextName}_${change.source}_3`}
                                              property={"New State"}
                                              content={`${change.newState}`}
                                              classes={{
                                                container: `${classes['propertyArea']} ${classes['propertyAreaMarginHorizontal']} ${classes['propertyAreaFlexGrow']}`,
                                                property: classes['propertyAreaProperty'],
                                                content: classes['propertyAreaContent']
                                              }}
                                            />
                                          </div>
                                      }
                                      {
                                          change.newTranslator !== undefined &&
                                            <div
                                              style={{
                                                width: "100%",
                                                paddingInline: ".5em",
                                                display: "flex",
                                                gap: ".5em",
                                                marginBlock: ".25em",
                                                marginBottom: ".5em",
                                                alignItems: "center"
                                              }}
                                            >
                                              <PropertyArea
                                                key={`${contextName}_${change.source}_4`}
                                                property={"Previous Translator"}
                                                content={`${change.initialTranslator || "\n"}`}
                                                classes={{
                                                  container: `${classes['propertyArea']} ${classes['propertyAreaMarginHorizontal']} ${classes['propertyAreaFlexGrow']}`,
                                                  property: classes['propertyAreaProperty'],
                                                  content: classes['propertyAreaContent']
                                                }}
                                              />
                                              <DoubleArrowRounded />
                                              <PropertyArea
                                                key={`${contextName}_${change.source}_5`}
                                                property={"New Translator"}
                                                content={`${change.newTranslator}`}
                                                classes={{
                                                  container: `${classes['propertyArea']} ${classes['propertyAreaMarginHorizontal']} ${classes['propertyAreaFlexGrow']}`,
                                                  property: classes['propertyAreaProperty'],
                                                  content: classes['propertyAreaContent']
                                                }}
                                              />
                                            </div>
                                      }
                                    </>
                                  }
                                />
                              ))
                            }
                          />
                        ))
                      }
                    </Box>
                  </Box>
                </Box>
                <IconButton
                  className={classes.modalButtonClose}
                  onClick={() => {
                    setHistoryEntryChanges({})
                    setHistoryModalOpen(false)
                  }}
                >
                  <CloseRounded />
                </IconButton>
              </Box>
            </Modal>
        }
      </Container>
    </Navigation>
  )
}